<template>
  <div class="common-bg index-bg" v-if="bannerList.length > 0">
    <!-- <div id="redPacket" v-if="$store.state.appInfo.redpacket_switch == 1 && hongbashow">
      <i @click="$parent.goNav('/hongbao')" class="grab"></i>
      <img @click="changhongbashow" src="/static/newImg/kjrk_icon_guanbi.avif" />
    </div> -->
    <!-- 左侧广告 -->
    <div class="side-ad side-ad-left" :class="{ scrolling: sideAdScrolling }" v-if="sideAdLeftShow">
      <div class="side-ad-close" @click="sideAdLeftShow = false">
        <img src="/static/newImg/kjrk_icon_guanbi.avif" style="width: .46rem;height:.46rem" />
      </div>
      <img src="/static/newImg/index/side/lt_01.webp" class="side-ad-img" />
      <img src="/static/newImg/index/side/lt_02.avif" class="side-ad-img" />
      <img src="/static/newImg/index/side/lt_03.avif" class="side-ad-img" />
    </div>
    <!-- 右侧广告 -->
    <div class="side-ad side-ad-right" :class="{ scrolling: sideAdScrolling }" v-if="sideAdRightShow">
      <div class="side-ad-close" @click="sideAdRightShow = false">
        <img src="/static/newImg/kjrk_icon_guanbi.avif" style="width: .46rem;height:.46rem" />
      </div>
      <img src="/static/newImg/index/side/rt_01.webp" class="side-ad-img" />
      <img src="/static/newImg/index/side/rt_02.avif" class="side-ad-img" />
      <img src="/static/newImg/index/side/rt_03.avif" class="side-ad-img" />
    </div>


    <div class="topInfo" :style="appshow?'top:0.87rem':'top:0'">
      <!-- 底层背景图 25% 50% 25% -->
      <div class="top-bg-layer">
        <div class="top-bg-left"><img src="/static/newImg/index/cion/01.avif" alt="" /></div>
        <div class="top-bg-center"><img src="/static/newImg/index/cion/02.avif" alt="" /></div>
        <div class="top-bg-right"><img src="/static/newImg/index/cion/03.avif" alt="" /></div>
      </div>
      <!-- 上层内容 40% 20% 40% -->
      <div class="top-content-layer">
        <div class="top-logo"><van-image  fit="contain" src="/static/newImg/static/logo.png"/></div>
        <div class="top-center">
          <van-image  fit="contain" src="/static/newImg/index/cion/04.webp"/>
        </div>
        <div class="top-right">
          <div class="search-wrap" @click="$router.push('/search')">
            <van-image height=".65rem" width=".65rem" src="/static/newImg/index/cion/05.avif" class="search-icon"/>
            <span class="search-text">搜索</span>
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="topInfo flex-c-b" :style="appshow?'top:1.27rem':'top:0'">
      <div class="logo">
        <van-image height=".85rem" fit="contain" src="/static/newImg/static/logo.png"/>
      </div>
      <div class="i flex-c-b">
        <div class="name flex-c-b" v-if="$store.state.token">
          <img :src="$store.state.userInfo.avatar ? $store.state.userInfo.avatar : '/static/image/imageAvatar02@3x.png'" alt="" />
          {{ $store.state.userInfo.username }}
        </div>
        <div class="mey flex-c-b" v-if="$store.state.token">
          <van-image height=".54rem" width=".54rem" src="/static/newImg/static/CNY.avif"/>
          <span class="m">{{ $store.state.userInfo.balance }}</span>
          <van-icon name="replay" color="#DFB372" size="15" />
        </div>
        <div class="ml flex-c-b" v-else>
          <div class="b b1" @click="loginNewShow = true">登 录</div>
          <div class="b b2" @click="loginNewShow = true">注 册</div>
          <van-image height=".45rem" width=".45rem" src="/static/newImg/static/index/icon_top_ss.avif"/>
        </div>
      </div>
    </div> -->
    
    <div class="appbox" v-if="appshow">
      <!-- <img class="colse" @click="appshow = false" src="/static/image/hongbaocolse.png" alt="" /> -->
      <van-icon name="cross" color="#ffbc6a" size="16" style="margin-right:0.2rem" @click="appshow = false" />
      <!-- <img class="logo" v-if="$store.state.appInfo.site_logo" :src="$store.state.appInfo.site_logo" alt="" />
      <img class="logo" v-else src="/static/image/app-logo.png" alt="" /> -->
       <van-image height=".93rem" fit="contain" src="/static/newImg/index/head/2002301428475740161.avif" width="80%"/>
      <!-- <div class="testz">
        <div class="tit">{{ $store.state.appInfo.title }}app</div>
        <div class="cx">真人娱乐，体育投注，电子游艺等尽在一手掌握</div>
      </div> -->
      <!--  -->
      <!-- <van-button type="info" style="background: #000; background-size: 100% 100%; font-size: 0.24rem; border: none; border-radius: 1rem; height: 0.6rem" @click="$parent.goNav('/app')">立即下载</van-button> -->
      <span class="btn" @click="openAppDownloadPopup">立即下载</span>
      <!-- btnBg.png -->
    </div>
    <div class="top-swiper-box" style="position: relative">
      <!-- <div class="homeHeder">
        <img class="leftImg" @click="changleftshow" src="/static/image/home_muen.png" alt="" />
        <div class="rbox" @click="$parent.openKefu">
          <img src="/static/image/home_service.png" alt="" />
          客服
        </div>
      </div> -->
      <div class="swiper-box" :style="appshow?'padding: 2.2rem .3rem 0':'padding: 1.45rem .3rem 0'">
      
      <div class="menu-icons">
        <div class="menu-icon-item" v-for="i in 6" :key="i">
          <img :src="`/static/newImg/index/menu/00${i}${i === 1 ? '.webp' : '.avif'}`" alt="" />
        </div>
      </div>
      
      <van-swipe @change="onChange" show-indicators indicator-color="#fff" :autoplay="bannerAutoplay" height="112">
        <van-swipe-item class="swiper-box-item" v-for="(item, index) in bannerList" :key="index">
          <img :src="item.src" style="width: 100%; height: 100%; object-fit: contain" />
        </van-swipe-item>
        <!-- <template #indicator>
          <div class="swiper-dots">
            <div class="num">{{ current + 1 }}</div>
            <div class="sign">/</div>
            <div class="num">4</div>
          </div>
        </template> -->
      </van-swipe>
      </div>
    </div>

    <div class="gonggao-bg" v-if="homePaomadeng && homePaomadeng.name">
    <!-- 公告 -->
      <div class="gonggao">
        <img style="width: 20px" src="/static/newImg/index/icon_dt_pmd.webp" alt="" />
        <div style="flex: 1">
          <van-notice-bar color="#f0c059" background="rgba(0,0,0,0)" scrollable speed="25"><span @click="openGogao(homePaomadeng)">{{ homePaomadeng.name }}</span></van-notice-bar>
        </div>
        <div class="dot-box">
          <van-image @click="goNotice" width=".8rem"  fit="contain" src="/static/newImg/index/icon_dt_1xx_wd.avif"/>
          <span class="dot" v-if="homeUnread > 0">{{ homeUnread > 99 ? '99+' : homeUnread }}</span>
        </div>
      </div>
      <div class="banner-img-box" style="width:98%;margin:auto;">
        <img src="/static/newImg/index/2083125678759653378.webp" style="width:100%" />
      </div>
    <!-- 公告 -->
      <!-- <div class="domainModal_domainView__FWCzg" v-if="goInfo">
        <div class="domainModal_mask__24Y2m domainModal_fadeIn__1I3AS false" @click="goInfo = null"></div>
        <div class="domainModal_content__1nBgc" style="width: 80%">
          <img src="/static/image/hongbaocolse.png" @click="goInfo = null" style="position: absolute; top: 5px; right: 13px; width: 0.7rem" alt="" />

          <div class="domainModal_middle__3gQPm" style="padding: 35px 10px 15px">
            {{ goInfo }}

            <van-button type="info" style="margin: 0 auto; margin-top: 20px; width: 120px; border-radius: 10px; height: 35px" @click="$parent.goNav('/message')">更多公告</van-button>
          </div>
        </div>
      </div> -->

      <!-- <div class="ren-box">
        <van-row gutter="20">
          <van-col span="8">
            <div class="lisImg" @click="goActivityDetail('1', '2')">
              <van-image height="2.24rem" fit="contain" src="/static/newImg/static/index/index_ren1.avif"/>
            </div>
          </van-col>
          <van-col span="8">
            <div class="lisImg" @click="openCheckIn">
              <van-image height="2.24rem" fit="contain" src="/static/newImg/static/index/index_ren2.avif"/>
            </div>
          </van-col>
          <van-col span="8">
            <div class="lisImg" @click="goActivityDetail('2', '7')">
              <van-image height="2.24rem" fit="contain" src="/static/newImg/static/index/index_ren3.avif"/>
            </div>
          </van-col>
        </van-row>
      </div> -->

      <!-- <div class="xiding">
        <div class="caosuo">
          <div class="lefsg" v-if="$store.state.token">
            <div class="name">{{ $store.state.userInfo.username }}</div>
            <div class="mey"><span>￥</span>{{ $store.state.userInfo.balance }}</div>
          </div>
          <div v-else class="lefsg" @click="$parent.goNav('/')">
            <div class="name">未登录</div>
            <div class="mey">登录后查看</div>
          </div>
          <div class="riggs">
            <div class="lisImg" @click="$parent.goNav('/recharge')">
              <img src="/static/newImg/icon_cz.avif" alt="" />
              存款
            </div>
            <div class="lisImg" @click="$parent.goNav('/transfer')">
              <img src="/static/newImg/icon_zz.avif" alt="" />
              转账
            </div>
            <div class="lisImg" @click="$parent.goNav('/withdrawal')">
              <img src="/static/newImg/icon_tx.avif" alt="" />
              取款
            </div>
            <div class="lisImg" @click="$router.push({ path: '/activity', query: { tab: '3' } })">
              <img src="/static/newImg/icon_vip.avif" alt="" />
              VIP
            </div>
          </div> 
        </div> 
      </div>  -->

    <!-- 用户信息栏 -->
      <div class="xiding" ref="xidingRef">
        <div class="caosuo">
          <div class="user-area" v-if="$store.state.token">
            <div class="user-top">
              <van-icon :name="showUserDropdown ? 'arrow-up' : 'arrow-down'" size="18" color="#999" class="user-arrow" @click="showUserDropdown = !showUserDropdown" />
              <span class="user-name">{{ displayNameType === 'id' ? $store.state.userInfo.id : $store.state.userInfo.username }}</span>
              <img src="/static/newImg/index/copy01.png" class="copy-icon" />
            </div>
            <div class="user-bottom">
              <img src="/static/newImg/index/CNY.avif" class="cny-icon" />
              <span class="balance">{{ $store.state.userInfo.balance }}</span>
              <img src="/static/newImg/index/refresh01.png" class="refresh-icon" />
            </div>
          </div>
          <div class="user-area" v-else>
            <div class="login-btns">
              <div class="btn-login" @click="openLogin(1)">登录</div>
              <div class="btn-register" @click="openLogin(0)">注册</div>
            </div>
          </div>
          <div class="riggs">
            <div class="lisImg" @click="$router.push({ path: '/activity', query: { tab: '3' } })">
              <img src="/static/newImg/index/icon_dt_1vip.avif" alt="" />
              VIP
            </div>
            <div class="lisImg" @click="$parent.goNav('/promote')">
              <img src="/static/newImg/index/icon_dt_1tg.avif" alt="" />
              分享赚钱
            </div>
            <div class="lisImg" @click="$parent.openKefu()">
              <img src="/static/newImg/index/icon_dt_1kf.avif" alt="" />
              客服
            </div>
            <!-- 原跳转更多，保留 -->
            <!--
            <div class="lisImg" @click="openTabsMore()">
              <img src="/static/newImg/index/icon_dt_1gd.avif" alt="" />
              更多
            </div>
            -->
            <div class="lisImg" @click="toggleMorePopup">
              <img src="/static/newImg/index/icon_dt_1gd.avif" alt="" />
              更多
            </div>
          </div>
        </div>

        <div class="user-dropdown" v-if="showUserDropdown">
          <div class="dropdown-title">默认展示信息</div>
          <div class="dropdown-item" :class="{ active: displayNameType === 'username' }" @click="displayNameType = 'username'; showUserDropdown = false">
            <van-icon name="contact-o" size="18" :color="displayNameType === 'username' ? '#DFB372' : '#999'" />
            <span :style="{ fontSize: '0.35rem', color: displayNameType === 'username' ? '#DFB372' : '#999' }">{{ $store.state.userInfo.username }}</span>
          </div>
          <div class="dropdown-item" :class="{ active: displayNameType === 'id' }" @click="displayNameType = 'id'; showUserDropdown = false">
            <span class="id-label" :style="{ color: displayNameType === 'id' ? '#DFB372' : '#999' }">ID</span>
            <span :style="{ fontSize: '0.35rem', color: displayNameType === 'id' ? '#DFB372' : '#999' }">{{ $store.state.userInfo.id }}</span>
          </div>
        </div>
      </div>

    </div>

    <!-- sports-box 暂时注释
    <div class="sports-box">
      <div class="sports-header">
        <div class="sports-title">
          <img src="/static/newImg/index/icon_dtfl_ty_1.avif" style="width:0.5rem;height:0.5rem" />
          <span>体育赛事</span>
        </div>
        <div class="sports-more" @click="$parent.goNav('/sports')">更多 <van-icon name="arrow" /></div>
      </div>
      <div class="sports-list">
        <div class="sports-card" v-for="(item, idx) in sportsList" :key="idx">
          <div class="sports-match-info">
            <span class="match-time">{{ item.time }}</span>
            <span class="match-league"><img src="/static/newImg/index/country/79c1d2a20ce3d107f604a9683b196301.png" style="width:0.45rem;height:0.45rem;vertical-align:middle" /> {{ item.league }}</span>
            <span class="match-num">{{ item.num }} <van-icon name="arrow" size="12" /></span>
          </div>
          <div class="sports-teams">
            <div class="team">
              <img :src="item.flag1" class="team-flag" />
              <span class="team-name">{{ item.team1 }}</span>
            </div>
            <div class="vs-wrap">
              <span class="vs-text">VS</span>
              <span class="vs-sub">全场独赢</span>
            </div>
            <div class="team">
              <img :src="item.flag2" class="team-flag" />
              <span class="team-name">{{ item.team2 }}</span>
            </div>
          </div>
          <div class="sports-odds">
            <div class="odd-item">
              <span class="odd-label">主</span>
              <span class="odd-value">{{ item.odds1 }}</span>
            </div>
            <div class="odd-item">
              <span class="odd-label">和</span>
              <span class="odd-value">{{ item.odds2 }}</span>
            </div>
            <div class="odd-item">
              <span class="odd-label">客</span>
              <span class="odd-value">{{ item.odds3 }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    -->

    <div class="game-category-box">
      <div class="game-category-layout">
        <div class="game-sidebar">
          <div class="sidebar-item" :class="{ active: activeGameTab === 0 }" @click="scrollToGameSection(0)">
            <img src="/static/newImg/index/game/icon_dtfl_1.avif" style="width:0.6rem;height:0.6rem" />
            <span>热门</span>
          </div>
          <div class="sidebar-item" :class="{ active: activeGameTab === 1 }" @click="scrollToGameSection(1)">
            <img src="/static/newImg/index/game/icon_dtfl_2.avif" style="width:0.6rem;height:0.6rem" />
            <span>电子</span>
          </div>
          <div class="sidebar-item" :class="{ active: activeGameTab === 2 }" @click="scrollToGameSection(2)">
            <img src="/static/newImg/index/game/icon_dtfl_3.avif" style="width:0.6rem;height:0.6rem" />
            <span>棋牌</span>
          </div>
          <div class="sidebar-item" :class="{ active: activeGameTab === 3 }" @click="scrollToGameSection(3)">
            <img src="/static/newImg/index/game/icon_dtfl_4.avif" style="width:0.6rem;height:0.6rem" />
            <span>捕鱼</span>
          </div>
          <div class="sidebar-item" :class="{ active: activeGameTab === 4 }" @click="scrollToGameSection(4)">
            <img src="/static/newImg/index/game/icon_dtfl_5.avif" style="width:0.6rem;height:0.6rem" />
            <span>真人</span>
          </div>
          <div class="sidebar-item" :class="{ active: activeGameTab === 5 }" @click="scrollToGameSection(5)">
            <img src="/static/newImg/index/game/icon_dtfl_6.avif" style="width:0.6rem;height:0.6rem" />
            <span style="letter-spacing:0">区块链</span>
          </div>
          <div class="sidebar-item" :class="{ active: activeGameTab === 6 }" @click="scrollToGameSection(6)">
            <img src="/static/newImg/index/game/icon_dtfl_7.avif" style="width:0.6rem;height:0.6rem" />
            <span>体育</span>
          </div>
          <div class="sidebar-item" :class="{ active: activeGameTab === 7 }" @click="scrollToGameSection(7)">
            <img src="/static/newImg/index/game/icon_dtfl_8.avif" style="width:0.6rem;height:0.6rem" />
            <span>彩票</span>
          </div>
        </div>
        <div class="game-content" ref="gameContent" @scroll="onGameContentScroll">
          <div class="game-top-tabs">
            <span :class="{ active: gameTopTab === 0 }" @click="gameTopTab = 0">热门</span>
            <span :class="{ active: gameTopTab === 1 }" @click="gameTopTab = 1">最近</span>
            <span :class="{ active: gameTopTab === 2 }" @click="gameTopTab = 2">收藏</span>
          </div>
          <div class="game-section" id="gameSection0" ref="gameSection0">
            <div class="section-header">
              <div class="section-title">
                <img src="/static/newImg/index/game/icon_dtfl_1.avif" style="width:0.6rem;height:0.6rem" />
                <span>{{ gameTopTab === 0 ? '热门游戏' : gameTopTab === 1 ? '最近游戏' : '收藏游戏' }}</span>
              </div>
              <span class="section-all" @click="$parent.goNav('/gameList?type=0')">全部</span>
            </div>
            <div class="game-grid">
              <div class="game-card" v-for="(item, idx) in getVisibleGames(gameTopTab === 0 ? $store.state.hotList : gameTopTab === 1 ? $store.state.recentList : $store.state.favoriteList, 'hot')" :key="'hot'+idx" @click="handleGameClick(item)">
                <img :src="item.mobile_img" loading="lazy" @error="handleImageError($event)" />
                <img class="game-card-collect" :src="item.is_favorite ? '/static/newImg/index/game/btn_collect_ok.avif' : '/static/newImg/index/game/btn_collect_wait.avif'" @click.stop="toggleFavorite(item)" />
                <span class="game-card-name" v-if="!item.mobile_img_has_text"><img class="game-card-head" :src="item.api_logo_img" loading="lazy" /> {{ item.game_name }}</span>
                <span class="game-card-label" v-if="item.tag && !item.mobile_img_has_text">{{ item.tag }}</span>
              </div>
            </div>
            <div class="section-expand" v-if="(gameTopTab === 0 ? $store.state.hotList : gameTopTab === 1 ? $store.state.recentList : $store.state.favoriteList).length > 9">
              <span v-if="sectionVisibleCount.hot < (gameTopTab === 0 ? $store.state.hotList : gameTopTab === 1 ? $store.state.recentList : $store.state.favoriteList).length" @click="expandSection('hot', (gameTopTab === 0 ? $store.state.hotList : gameTopTab === 1 ? $store.state.recentList : $store.state.favoriteList).length)">另有{{ (gameTopTab === 0 ? $store.state.hotList : gameTopTab === 1 ? $store.state.recentList : $store.state.favoriteList).length - sectionVisibleCount.hot }}款游戏 展开 <van-icon name="arrow-down" /></span>
              <span v-else class="loaded-text">已加载完成</span>
            </div>
          </div>
          <div class="game-section" id="gameSection1" ref="gameSection1">
            <div class="section-header">
              <div class="section-title">
                <img src="/static/newImg/index/game/icon_dtfl_2.avif" style="width:0.65rem;height:0.6rem" />
                <span>电子游戏</span>
              </div>
              <span class="section-all" @click="$parent.goNav('/gameList?type=3')">全部</span>
            </div>
            <div class="jackpot-banner">
              <img src="/static/newImg/index/game/2018873998132793345.webp" style="width:100%;border-radius:0.1rem" />
              <div class="jackpot-text">321,549,474,10</div>
            </div>
            <div class="game-grid">
              <div class="game-card" v-for="(item, idx) in getVisibleGames($store.state.realbetList, 'electronic')" :key="'elec'+idx" @click="handleGameClick(item)">
                <img :src="item.mobile_img" loading="lazy" @error="handleImageError($event)" />
                <img class="game-card-collect" :src="item.is_favorite ? '/static/newImg/index/game/btn_collect_ok.avif' : '/static/newImg/index/game/btn_collect_wait.avif'" @click.stop="toggleFavorite(item)" />
                <span class="game-card-name" v-if="!item.mobile_img_has_text"><img class="game-card-head" :src="item.api_logo_img" loading="lazy" /> {{ item.game_name }}</span>
                <span class="game-card-label" v-if="item.tag && !item.mobile_img_has_text">{{ item.tag }}</span>
              </div>
            </div>
            <div class="section-expand" v-if="$store.state.realbetList.length > 9">
              <span v-if="sectionVisibleCount.electronic < $store.state.realbetList.length" @click="expandSection('electronic', $store.state.realbetList.length)">另有{{ $store.state.realbetList.length - sectionVisibleCount.electronic }}款游戏 展开 <van-icon name="arrow-down" /></span>
              <span v-else class="loaded-text">已加载完成</span>
            </div>
          </div>
          <div class="game-section" id="gameSection2" ref="gameSection2">
            <div class="section-header">
              <div class="section-title">
                <img src="/static/newImg/index/game/icon_dtfl_3.avif" style="width:0.6rem;height:0.6rem" />
                <span>棋牌游戏</span>
              </div>
              <span class="section-all" @click="$parent.goNav('/gameList?type=6')">全部</span>
            </div>
            <div class="game-grid">
              <div class="game-card" v-for="(item, idx) in getVisibleGames($store.state.jokerList, 'card')" :key="'qp'+idx" @click="handleGameClick(item)">
                <img :src="item.mobile_img" loading="lazy" @error="handleImageError($event)" />
                <img class="game-card-collect" :src="item.is_favorite ? '/static/newImg/index/game/btn_collect_ok.avif' : '/static/newImg/index/game/btn_collect_wait.avif'" @click.stop="toggleFavorite(item)" />
                <span class="game-card-name" v-if="!item.mobile_img_has_text"><img class="game-card-head" :src="item.api_logo_img" loading="lazy" /> {{ item.game_name }}</span>
                <span class="game-card-label" v-if="item.tag && !item.mobile_img_has_text">{{ item.tag }}</span>
              </div>
            </div>
            <div class="section-expand" v-if="$store.state.jokerList.length > 9">
              <span v-if="sectionVisibleCount.card < $store.state.jokerList.length" @click="expandSection('card', $store.state.jokerList.length)">另有{{ $store.state.jokerList.length - sectionVisibleCount.card }}款游戏 展开 <van-icon name="arrow-down" /></span>
              <span v-else class="loaded-text">已加载完成</span>
            </div>
          </div>
          <div class="game-section" id="gameSection3" ref="gameSection3">
            <div class="section-header">
              <div class="section-title">
                <img src="/static/newImg/index/game/icon_dtfl_4.avif" style="width:0.65rem;height:0.6rem" />
                <span>捕鱼游戏</span>
              </div>
              <span class="section-all" @click="$parent.goNav('/gameList?type=2')">全部</span>
            </div>
            <div class="game-grid">
              <div class="game-card" v-for="(item, idx) in getVisibleGames($store.state.gamingList, 'fishing')" :key="'by'+idx" @click="handleGameClick(item)">
                <img :src="item.mobile_img" loading="lazy" @error="handleImageError($event)" />
                <img class="game-card-collect" :src="item.is_favorite ? '/static/newImg/index/game/btn_collect_ok.avif' : '/static/newImg/index/game/btn_collect_wait.avif'" @click.stop="toggleFavorite(item)" />
                <span class="game-card-name" v-if="!item.mobile_img_has_text"><img class="game-card-head" :src="item.api_logo_img" loading="lazy" /> {{ item.game_name }}</span>
                <span class="game-card-label" v-if="item.tag && !item.mobile_img_has_text">{{ item.tag }}</span>
              </div>
            </div>
            <div class="section-expand" v-if="$store.state.gamingList.length > 9">
              <span v-if="sectionVisibleCount.fishing < $store.state.gamingList.length" @click="expandSection('fishing', $store.state.gamingList.length)">另有{{ $store.state.gamingList.length - sectionVisibleCount.fishing }}款游戏 展开 <van-icon name="arrow-down" /></span>
              <span v-else class="loaded-text">已加载完成</span>
            </div>
          </div>
          <div class="game-section" id="gameSection4" ref="gameSection4">
            <div class="section-header">
              <div class="section-title">
                <img src="/static/newImg/index/game/icon_dtfl_5.avif" style="width:0.6rem;height:0.6rem" />
                <span>真人游戏</span>
              </div>
              <span class="section-all" @click="$parent.goNav('/gameList?type=1')">全部</span>
            </div>
            <div class="game-grid">
              <div class="game-card" v-for="(item, idx) in getVisibleGames($store.state.sportList, 'realperson')" :key="'zr'+idx" @click="handleGameClick(item)">
                <img :src="item.mobile_img" loading="lazy" @error="handleImageError($event)" />
                <img class="game-card-collect" :src="item.is_favorite ? '/static/newImg/index/game/btn_collect_ok.avif' : '/static/newImg/index/game/btn_collect_wait.avif'" @click.stop="toggleFavorite(item)" />
                <span class="game-card-name" v-if="!item.mobile_img_has_text"><img class="game-card-head" :src="item.api_logo_img" loading="lazy" /> {{ item.game_name }}</span>
                <span class="game-card-label" v-if="item.tag && !item.mobile_img_has_text">{{ item.tag }}</span>
              </div>
            </div>
            <div class="section-expand" v-if="$store.state.sportList.length > 9">
              <span v-if="sectionVisibleCount.realperson < $store.state.sportList.length" @click="expandSection('realperson', $store.state.sportList.length)">另有{{ $store.state.sportList.length - sectionVisibleCount.realperson }}款游戏 展开 <van-icon name="arrow-down" /></span>
              <span v-else class="loaded-text">已加载完成</span>
            </div>
          </div>
          <div class="game-section" id="gameSection5" ref="gameSection5">
            <div class="section-header">
              <div class="section-title">
                <img src="/static/newImg/index/game/icon_dtfl_6.avif" style="width:0.6rem;height:0.6rem" />
                <span>区块链游戏</span>
              </div>
              <span class="section-all" @click="$parent.goNav('/gameList?type=8')">全部</span>
            </div>
            <div class="game-grid">
              <div class="game-card" v-for="(item, idx) in getVisibleGames($store.state.conciseList, 'blockchain')" :key="'qkl'+idx" @click="handleGameClick(item)">
                <img :src="item.mobile_img" loading="lazy" @error="handleImageError($event)" />
                <img class="game-card-collect" :src="item.is_favorite ? '/static/newImg/index/game/btn_collect_ok.avif' : '/static/newImg/index/game/btn_collect_wait.avif'" @click.stop="toggleFavorite(item)" />
                <span class="game-card-name" v-if="!item.mobile_img_has_text"><img class="game-card-head" :src="item.api_logo_img" loading="lazy" /> {{ item.game_name }}</span>
                <span class="game-card-label" v-if="item.tag && !item.mobile_img_has_text">{{ item.tag }}</span>
              </div>
            </div>
            <div class="section-expand" v-if="$store.state.conciseList.length > 9">
              <span v-if="sectionVisibleCount.blockchain < $store.state.conciseList.length" @click="expandSection('blockchain', $store.state.conciseList.length)">另有{{ $store.state.conciseList.length - sectionVisibleCount.blockchain }}款游戏 展开 <van-icon name="arrow-down" /></span>
              <span v-else class="loaded-text">已加载完成</span>
            </div>
          </div>
          <div class="game-section" id="gameSection6" ref="gameSection6">
            <div class="section-header">
              <div class="section-title">
                <img src="/static/newImg/index/game/icon_dtfl_7.avif" style="width:0.65rem;height:0.6rem" />
                <span>体育游戏</span>
              </div>
              <span class="section-all" @click="$parent.goNav('/gameList?type=5')">全部</span>
            </div>
            <div class="game-grid">
              <div class="game-card" v-for="(item, idx) in getVisibleGames($store.state.tiyuList, 'tiyu')" :key="'ty'+idx" @click="handleGameClick(item)">
                <img :src="item.mobile_img" loading="lazy" @error="handleImageError($event)" />
                <img class="game-card-collect" :src="item.is_favorite ? '/static/newImg/index/game/btn_collect_ok.avif' : '/static/newImg/index/game/btn_collect_wait.avif'" @click.stop="toggleFavorite(item)" />
                <span class="game-card-name" v-if="!item.mobile_img_has_text"><img class="game-card-head" :src="item.api_logo_img" loading="lazy" /> {{ item.game_name }}</span>
                <span class="game-card-label" v-if="item.tag && !item.mobile_img_has_text">{{ item.tag }}</span>
              </div>
            </div>
            <div class="section-expand" v-if="$store.state.tiyuList.length > 9">
              <span v-if="sectionVisibleCount.tiyu < $store.state.tiyuList.length" @click="expandSection('tiyu', $store.state.tiyuList.length)">另有{{ $store.state.tiyuList.length - sectionVisibleCount.tiyu }}款游戏 展开 <van-icon name="arrow-down" /></span>
              <span v-else class="loaded-text">已加载完成</span>
            </div>
          </div>
          <div class="game-section" id="gameSection7" ref="gameSection7">
            <div class="section-header">
              <div class="section-title">
                <img src="/static/newImg/index/game/icon_dtfl_8.avif" style="width:0.6rem;height:0.6rem" />
                <span>彩票游戏</span>
              </div>
              <span class="section-all" @click="$parent.goNav('/gameList?type=4')">全部</span>
            </div>
            <div class="game-grid">
              <div class="game-card" v-for="(item, idx) in getVisibleGames($store.state.lotteryList, 'lottery')" :key="'cp'+idx" @click="handleGameClick(item)">
                <img :src="item.mobile_img" loading="lazy" @error="handleImageError($event)" />
                <img class="game-card-collect" :src="item.is_favorite ? '/static/newImg/index/game/btn_collect_ok.avif' : '/static/newImg/index/game/btn_collect_wait.avif'" @click.stop="toggleFavorite(item)" />
                <span class="game-card-name" v-if="!item.mobile_img_has_text"><img class="game-card-head" :src="item.api_logo_img" loading="lazy" /> {{ item.game_name }}</span>
                <span class="game-card-label" v-if="item.tag && !item.mobile_img_has_text">{{ item.tag }}</span>
              </div>
            </div>
            <div class="section-expand" v-if="$store.state.lotteryList.length > 9">
              <span v-if="sectionVisibleCount.lottery < $store.state.lotteryList.length" @click="expandSection('lottery', $store.state.lotteryList.length)">另有{{ $store.state.lotteryList.length - sectionVisibleCount.lottery }}款游戏 展开 <van-icon name="arrow-down" /></span>
              <span v-else class="loaded-text">已加载完成</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="brand-intro">
      <div class="brand-img">
        <img src="/static/newImg/index/game/2074015439856791553.avif" style="width:100%" />
      </div>
      <div class="brand-desc">
        澳门新蒲京集团是国际最知名的线上博彩运营公司，提供刺激好玩的真人荷官娱乐城、电子、棋牌、捕鱼、体彩等全品类游戏。由澳门特别行政区授权和监管，已通过所有合规性审查和获得合法授权，并颁发了运营许可证，进行游戏娱乐请确保您已年满18周岁。
      </div>
      <div class="brand-logo">
        <img src="/static/newImg/index/game/2008047668383506434.avif" style="width:100%" />
      </div>
      <div class="brand-copyright">
        澳门新蒲京集团@版权所有 2002-2030
      </div>
    </div>

    <!-- <div class="gameHots-box">
      <div class="title flex-c-c">
        <van-image  width="1.49rem" height="0.35rem" fit="contain" src="/static/newImg/img_tsyx_djjj1.avif"/>
        &nbsp;火爆推荐&nbsp;
        <van-image  width="1.49rem" height="0.35rem" fit="contain" src="/static/newImg/img_tsyx_djjj2.avif" style="transform: scaleX(-1);"/>
      </div>
      <div class="gameHots-cell">
        <van-swipe class="my-swipe" indicator-color="white" height="180">
          <van-swipe-item v-for="(item, index) in hotsList" :key="index" class="gameHots-item">
            <template #default>
              <div class="flex-c-c">
                <van-row :gutter="20">
                <van-col span="12">
                  <div class="hots-content big">
                    <van-image fit="cover" :src="item.children[0].img" radius="4"/>
                    <div class="name">{{item.children[0].name}}</div>
                  </div>
                </van-col>

                  <van-col span="12" class="flex-c-b grid">
                    <div class="hots-content " v-for="(child, cIndex) in item.children.slice(1)" :key="cIndex">
                      <van-image fit="cover" :src="child.img" radius="4"/>
                      <div class="name">{{child.name}}</div>
                    </div>
                  </van-col>
                </van-row>

              </div>
            </template>
          </van-swipe-item>
        </van-swipe>
      </div>
    </div> -->
    
    <!-- 游戏栏新 -->
     <!-- <div class="index-gameBoxs-new">

      <div class="cell-big">
        <div class="cell" @click="changGameType('4')">
          <div class="title">
            <div class="cn">电子</div>
            <div class="en">SLOT</div>
          </div>
          <van-image  width="8.5rem" height="3.48rem" fit="contain" src="/static/newImg/game/img_syyx_cjc.avif"/>
        </div>
        <div class="hot"><van-image  width="0.57rem" height="0.64rem" fit="contain" src="/static/newImg/game/img_game_tj.avif"/></div>
      </div>
      
      <div class="cell-middle flex-c-b">
        <div class="cell" @click="changGameType('3')">
          <div class="title">
            <div class="cn">棋牌</div>
            <div class="en">CARDS</div>
          </div>
          <van-image width="6.5rem" height="2.48rem" fit="contain" src="/static/newImg/game/img_syyx2_1.avif"/>
        </div>
        <div class="cell" @click="changGameType('6')">
          <div class="title">
            <div class="cn">捕鱼</div>
            <div class="en">E-SPORTS</div>
          </div>
          <van-image  width="6.5rem" height="2.48rem" fit="contain" src="/static/newImg/game/img_syyx2_2.avif"/>
        </div>
      </div>

      <div class="cell-small flex-c-b">
        <div class="cell" @click="changGameType('0')">
          <div class="title">
            <div class="cn">真人</div>
            <div class="en">LIVE</div>
          </div>
          <div class="img-game1">
          </div>
        </div>
        <div class="cell" @click="changGameType('1')">
          <div class="title">
            <div class="cn">体育</div>
            <div class="en">SPORTS</div>
          </div>
          <div class="img-game2">
          </div>
        </div>
        <div class="cell" @click="changGameType('5')">
          <div class="title">
            <div class="cn">彩票</div>
            <div class="en">LOTTERY</div>
          </div>
          <div class="img-game3">
          </div>
        </div>
        <div class="cell" @click="openGameMore()">
          <div class="title">
            <div class="cn">更多</div>
            <div class="en">MORE</div>
          </div>
          <div class="img-game4">
          </div>
        </div>
      </div>
     </div> -->

    <!-- 游戏栏新 -->

    <!-- <div class="gameAward-box">
      <div class="title flex-c-c">
        <van-image  width="1.49rem" height="0.35rem" fit="contain" src="/static/newImg/img_tsyx_hbtj1.avif"/>
        &nbsp;大奖记录&nbsp;
        <van-image  width="1.49rem" height="0.35rem" fit="contain" src="/static/newImg/img_tsyx_hbtj2.avif" style="transform: scaleX(-1);"/>
      </div>
      <div class="gameAward">
        <van-notice-bar scrollable speed="20">
          <template #default>
            <div class="flex-c-c">
            <div class="notice-content" v-for="(item, index) in awardList" :key="index">
              <van-image width="1.8rem" fit="cover" :src="item.img" radius="4"/>
              <span class="name">{{item.name}}<span>中奖</span></span>
              <span class="bei">{{item.bei}}倍</span>
            </div>
            </div>
          </template>
        </van-notice-bar>
      </div>
    </div>

    <div class="lianxi-box">
      <div class="title">联系我们</div>
      <div class="lianxi">
        <button onclick="window.location.href='mailto:someone@example.com?subject=邮件主题&body=邮件正文';" style="width: 1rem;height: 1rem;background: none;border: none;padding: 0;cursor: pointer;">
          <van-image width="1rem" height="1rem" fit="cover" src="/static/newImg/emil-icon.avif"/>
        </button>
      </div>
    </div> -->

    <!-- 游戏栏 -->
    
    <!-- <div class="gameBoxs">
      <div class="lfst">
        <div :class="gameType == 0 ? 'ls active' : 'ls'" @click="changGameType(0)">
          <img :src="`/static/style/${gameType == 0 ? 'sidebar_casino_icon_select' : 'sidebar_casino_icon_nor'}.png`" alt="" />
          <span>真人</span>
        </div>
        <div :class="gameType == 1 ? 'ls active' : 'ls'" @click="changGameType(1)">
          <img :src="`/static/style/${gameType == 1 ? 'sidebar_sports_icon_select' : 'sidebar_sports_icon_nor'}.png`" alt="" />

          <span>体育</span>
        </div>
        <div :class="gameType == 2 ? 'ls active' : 'ls'" @click="changGameType(2)">
          <img :src="`/static/style/${gameType == 2 ? 'sidebar_esports_icon_select' : 'sidebar_esports_icon_nor'}.png`" alt="" />

          <span>电竞</span>
        </div>
        <div :class="gameType == 3 ? 'ls active' : 'ls'" @click="changGameType(3)">
          <img :src="`/static/style/${gameType == 3 ? 'sidebar_board_icon_select' : 'sidebar_board_icon_nor'}.png`" alt="" />

          <span>棋牌</span>
        </div>
        <div :class="gameType == 4 ? 'ls active' : 'ls'" @click="changGameType(4)">
          <img :src="`/static/style/${gameType == 4 ? 'sidebar_slot_icon_select' : 'sidebar_slot_icon_nor'}.png`" alt="" />

          <span>电子</span>
        </div>
        <div :class="gameType == 5 ? 'ls active' : 'ls'" @click="changGameType(5)">
          <img :src="`/static/style/${gameType == 5 ? 'sidebar_lottery_icon_select' : 'sidebar_lottery_icon_nor'}.png`" alt="" />

          <span>彩票</span>
        </div>
      </div>

      <div class="rigts" v-if="gameType == 0">
        <img class="" v-for="(item, index) in $store.state.realbetList" :key="index" @click="$parent.openGamePage(item.platform_name, item.game_code, '')" :src="item.mobile_img" loading="lazy" @error="handleImageError($event)" :alt="item.platform_name" :title="item.platform_name" />
      </div>
      <div class="rigts" v-if="gameType == 1">
        <img class="" v-for="(item, index) in $store.state.sportList" :key="index" @click="$parent.openGamePage(item.platform_name, item.game_code, '')" :src="item.mobile_img" loading="lazy" @error="handleImageError($event)" :alt="item.platform_name" :title="item.platform_name" />
      </div>
      <div class="rigts" v-if="gameType == 2">
        <img class="" v-for="(item, index) in $store.state.gamingList" :key="index" @click="$parent.openGamePage(item.platform_name, item.game_code, '')" :src="item.mobile_img" loading="lazy" @error="handleImageError($event)" :alt="item.platform_name" :title="item.platform_name" />
      </div>
      <div class="rigts" v-if="gameType == 3">
        <img class="" v-for="(item, index) in $store.state.jokerList" :key="index" @click="$parent.openGamePage(item.platform_name, item.game_code, '')" :src="item.mobile_img" loading="lazy" @error="handleImageError($event)" :alt="item.platform_name" :title="item.platform_name" />
      </div>
      <div class="rigts" v-if="gameType == 4">
        <img class="" @click="$parent.goNav('/concise?type=obgdy')" src="/static/image/concise/obgdy.png" alt="" />
        <img class="" @click="$parent.goNav('/concise?type=fgdz')" src="/static/image/concise/fgdz.png" alt="" />
        <img class="" @click="$parent.goNav('/concise?type=pp')" src="/static/image/concise/pp.png" alt="" />
        <img class="" @click="$parent.goNav('/concise?type=ae')" src="/static/image/concise/ae.png" alt="" />
        <img class="" v-for="(item, index) in $store.state.conciseList" :key="index" @click="$parent.openGamePage(item.platform_name, item.game_code, '')" :src="item.mobile_img" loading="lazy" @error="handleImageError($event)" :alt="item.platform_name" :title="item.platform_name" />
      </div>
      <div class="rigts" v-if="gameType == 5">
        <img
          class=""
          v-for="(item, index) in $store.state.lotteryList"
          :key="index"
          @click="$parent.openGamePage(item.platform_name, item.game_code, '')"
          :style="item.platform_name == 'vrbet' ? 'width:100%' : ''"
          :src="item.mobile_img"
          @error="handleImageError($event)"
          :alt="item.platform_name"
          :title="item.platform_name"/>
      </div>
    </div> -->

    <!-- 弹出层 -->
    <van-popup v-model="leftshow" position="left" :style="{ height: '100%' }">
      <div class="leftbox">
        <div class="side__main__1NhyG">
          <h3>Hi，欢迎进入{{ $store.state.appInfo.title }}</h3>
          <dl class="side__vip__1dW8w">
            <div class="topxs">专属VIP体验</div>
            <p>立享会员特权</p>
            <p>享受只属于你的与众不同</p>
            <dd @click="$router.push({ path: '/activity', query: { tab: '3' } })">会员中心</dd>
          </dl>
          <ul>
            <li v-if="$store.state.token" @click="$parent.goNav('/message')"><img src="/static/image/meunIcon.39f38dc98ad956615952d485d0e6af04.svg" />消息中心<span class="side__subtitle__3QtYC"></span></li>
            <li @click="$parent.openKefu"><img src="/static/image/meunIcon2.5d0d78496889fb8b027f603254286fdf.svg" />意见反馈<span class="side__subtitle__3QtYC"></span></li>
            <li @click="doCopy($store.state.appInfo.h5_url)">
              <img src="/static/image/menuIcon5.5687ef4d1512d53aa3535e3b1088fe70.png" />永久域名<span class="side__subtitle__3QtYC">{{ $store.state.appInfo.h5_url }}</span>
            </li>
            <li @click="$parent.goNav('/abouts')"><img src="/static/image/meunIcon3.c51bbb9ebece978f1976397ab12acba7.svg" />关于我们<span class="side__subtitle__3QtYC"></span></li>
          </ul>
          <div class="nisd" v-if="!$store.state.token" @click="$parent.goNav('/')">立即登录</div>
          <div class="nisd" v-else @click="$parent.outLogin"><img src="/static/image/tuichu.93c1b9e3d4b4a7772481916ca32c074f.svg" />安全退出</div>
        </div>
      </div>
    </van-popup>

    <!-- 官网弹窗 -->
    <div class="domainModal_domainView__FWCzg" v-if="$store.state.appInfo.index_modal == 1 && tanshow">
      <div class="domainModal_mask__24Y2m domainModal_fadeIn__1I3AS false" @click="changtanshow"></div>
      <div class="domainModal_content__1nBgc" style="width: 80%">
        <div id="domain" class="domainModal_contentTop__2C4jc">
          <img src="/static/image/hongbaocolse.png" @click="changtanshow" style="position: absolute; top: 5px; right: 13px; width: 0.6rem" alt="" />

          <div class="domainModal_top__1omYS">欢迎来到{{ $store.state.appInfo.title }}</div>
          <div class="domainModal_middle__3gQPm" v-html="$store.state.appInfo.webcontent"></div>
        </div>
      </div>
    </div>

    <van-popup v-model="ssActiveShow" round style="background: transparent">
      <div class="ssActive-box">
        <van-swipe ref="swiperActive" class="my-swipeactive"  :autoplay="0" width="8.3rem" height="6.5rem">
          <van-swipe-item v-for="(item, index) in activePopupList" :key="index">
              <van-image width="8.3rem" height="6.5rem" radius=".25rem" fit="contain" :src="item.img"/>
          </van-swipe-item>
          <template #indicator>
            <van-tabs type="card" swipeable background="#292A2c" color="#DFB372" title-active-color="#292A2c" :border="false" :ellipsis="false" @click="goToSlide">
              <van-tab v-for="(item, index) in activePopupList" :key="index" :title="item.title">
                <template #title>
                  <van-icon name="volume" />&nbsp;{{ item.title }}
                </template>
              </van-tab>
            </van-tabs>
          </template>
        </van-swipe>
      </div>
      <div class="close-ssActive" @click="ssActiveShow = false"><van-icon name="close" color="#fff" size="30" /></div>
    </van-popup>

    <van-popup v-model="loginNewShow" round style="background: transparent" :close-on-click-overlay="true">
      <loginNewComponents v-if="loginNewShow" :defaultType="loginDefaultType" @close="handleColseLoginNew"></loginNewComponents>
      <div class="close-loginNew" @click="loginNewShow = false"><van-icon name="close" color="#fff" size="30" /></div>
    </van-popup>

    <!-- 签到弹框 -->
    <div class="checkin-overlay" v-if="checkinShow" @click.self="checkinShow = false">
      <!-- 装饰图（红包+日历）：独立放在弹框外，遮罩层内 -->
      <img src="/static/newImg/mine/qd_style_6_qdtc.avif" class="checkin-deco-img" alt="" />
      <div class="checkin-popup">
        <!-- 标题 -->
        <div class="sign-name"><p>天天签到 天天金喜</p></div>
        <!-- 连续签到信息 -->
        <div class="sign-summary">
          <div class="summary-item">
            <div class="item-left">已连续签到 <span class="num">{{ checkinData.consecutiveDays }}</span> 天</div>
            <div class="item-right"><span>已领取 <strong class="gold">{{ checkinData.totalClaimed }}</strong></span><img src="/static/newImg/static/index/refresh_icon.avif" class="refresh-icon" @click="checkinShow = false" alt="" /></div>
          </div>
        </div>
        <!-- 主体：列表滚动 -->
        <div class="sign-main">
          <div class="sign-grid">
            <div class="sign-item" v-for="(item, index) in checkinData.days" :key="index">
              <!-- 额外奖励绿色角标 -->
              <span v-if="item.extra" class="sign-extra">额外奖励</span>
              <!-- 奖励图 -->
              <div class="sign-reward-pattern">
                <img src="/static/newImg/mine/qd_style2_img_qdjb1.avif" class="reward-picture" alt="" />
              </div>
              <!-- 金额 -->
              <div class="sign-reward-desc">
                <div class="reward-text yellow">{{ item.reward }}</div>
              </div>
              <!-- 当前签到：按钮 / 其它：第X天 -->
              <div class="sign-caption">
                <button v-if="item.status === 'current' && checkinData.canSign" class="btn-sign" @click="handleSign">签到</button>
                <div v-else class="day-label">第{{ index + 1 }}天</div>
              </div>
            </div>
          </div>
          <!-- 活动说明（暂不修改） -->
          <div class="sign-intro" v-if="showRules">
            <div class="sign-intro-title">
              <div class="title-box"><span class="title-text">活动说明</span><i class="title-arrow"></i></div>
            </div>
            <div class="sign-intro-content">
              <p>充值+打码（连续7天后重置）</p>
              <p>1.每日充值且打码满足活动条件才能签到成功，可领取对应固定奖金或者神秘奖金；</p>
              <p>2.本活动属连续签到活动（若期间中断，将从第1天开始）；</p>
              <p>3.本活动所赠送的彩金（不含本金）需1倍流水（即稽核、打码或有效投注）才能提现，打码不限游戏平台；</p>
              <p>4.彩金限时领取24小时，过期作废（即未主动领取视为自愿放弃）；</p>
              <p>5.本活动仅限账号本人进行正常的人为操作，禁止租借、使用外挂、机器人、不同账号对赌、互刷、套利、接口、协议、利用漏洞、群控或其他技术手段参与，否则将取消或扣除彩金、冻结、甚至拉入黑名单；</p>
              <p>6.会员活动相关数据均由系统自动统计，若有任何异议，以PG集團系统统计结果为准；</p>
              <p>7.如您忘记会员账号，密码，请您联系7*24小时在线客服协助您取回您的账号信息；</p>
              <p>8.参与该优惠，即表示您同意《优惠规则与条款》。</p>
            </div>
          </div>
        </div>
        <!-- 所需充值 / 投注 -->
        <div class="sign-need">
          <div class="need-item fail">所需充值 <span class="num">{{ checkinData.needRecharge }}<span>/{{ checkinData.rechargeThreshold }}</span></span></div>
          <div class="need-item right fail">所需投注 <span class="num">{{ checkinData.needBet }}<span>/{{ checkinData.betThreshold }}</span></span></div>
        </div>
        <!-- 不再提示 移入弹框内底部 -->
        <div class="sign-persist">
          <label class="persist-item">
            <input type="checkbox" v-model="checkinDontShowToday" />
            <span>今日不再提示</span>
          </label>
          <label class="persist-item">
            <input type="checkbox" v-model="checkinDontShowAlways" />
            <span>永不提示</span>
          </label>
        </div>
      </div>
      <!-- 关闭按钮（弹框外，遮罩层内，下方中央圆形白×） -->
      <div class="checkin-close-btn" @click="checkinShow = false">
        <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="#000" stroke-width="2.5" stroke-linecap="round">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </div>
    </div>

    <!-- 温馨提示弹框 -->
    <div class="tip-overlay" v-if="tipShow" @click.self="tipShow = false">
      <div class="tip-popup">
        <div class="tip-title">温馨提示</div>
        <div class="tip-content">恭喜您已满足领取条件！只差最后一步，下载APP并登录，即可马上领取！</div>
        <div class="tip-btns">
          <button class="tip-btn-close" @click="tipShow = false">关闭</button>
          <button class="tip-btn-download">立即下载</button>
        </div>
      </div>
    </div>

    <!-- 更多弹框遮罩层 -->
    <div class="more-popup-mask" v-if="showMorePopup" @click="closeMorePopup"></div>

    <!-- 更多弹框 -->
    <div class="more-popup-float" v-if="showMorePopup" :style="{ top: morePopupTop }">
      <div class="more-popup-grid">
        <div class="more-popup-item" v-for="item in getVisibleMoreList()" :key="item.id" @click="handleMoreItemClick(item)">
          <div class="more-popup-icon">
            <img :src="item.icon" />
          </div>
          <span class="more-popup-name">{{ item.name }}</span>
        </div>
      </div>
    </div>

    <!-- 语言选择弹窗 -->
    <div class="lang-popup-mask" v-if="showLangPopup" @click="showLangPopup = false">
      <div class="lang-popup-content" @click.stop>
        <div class="lang-popup-title">选择语言</div>
        <div class="lang-popup-item">
          <span>简体中文</span>
          <div class="lang-radio-active">
            <van-icon name="success" color="#000" size="14" />
          </div>
        </div>
        <div class="lang-popup-close" @click="showLangPopup = false">
          <van-icon name="cross" color="#fff" size="24" />
        </div>
      </div>
    </div>

    <!-- APP下载弹框 -->
    <div class="app-download-mask" v-if="showAppDownloadPopup" @click="closeAppDownloadPopup">
      <div class="app-download-popup" @click.stop>
        <!-- 顶部：logo + 标题 -->
        <div class="app-download-header">
          <div class="app-download-logo">
            <img src="/static/newImg/static/logos.avif" alt="logo" />
          </div>
          <div class="app-download-title-wrap">
            <div class="app-download-title">下载APP免费领取百万现金</div>
          </div>
        </div>
        <!-- 下载按钮组 -->
        <div class="app-download-btns">
          <div class="app-download-row">
            <div class="app-download-btn app-download-btn-desktop">
              <span class="i-icon"><img :src="isIOS ? '/static/newImg/static/style20.avif' : '/static/newImg/static/style24.avif'" /></span>
              <span>桌面快捷方式</span>
            </div>
            <div v-if="isIOS" class="app-download-btn app-download-btn-official">
              <span class="i-icon"><img src="/static/newImg/static/style20.avif" /></span>
              <span>官方应用版</span>
            </div>
            <!-- 安卓版第二个按钮：上快捷APP + 下打勾自动登录 -->
            <div v-else class="app-download-btn app-download-btn-official app-download-btn-android-login">
              <span class="app-download-hot-tag">热门</span>
              <span class="i-icon"><img src="/static/newImg/static/style24.avif" /></span>
              <span class="android-login-text">
                <span class="android-login-top">快捷APP</span>
                <span class="android-login-bottom">
                  <span class="android-login-check">
                    <van-icon name="success" color="#fff" size="12" />
                  </span>
                  <span>自动登录</span>
                </span>
              </span>
            </div>
          </div>
          <!-- 第2行：仅iOS显示（快捷APP + 教程） -->
          <div v-if="isIOS" class="app-download-merged">
            <span class="app-download-hot-tag">热门</span>
            <div class="app-download-merged-left">
              <span class="i-icon"><img src="/static/newImg/static/style20.avif" /></span>
              <span>快捷APP</span>
            </div>
            <div class="app-download-merged-split"></div>
            <div class="app-download-merged-right">
              <span class="app-download-tutorial-icon">
                <img src="/static/newImg/static/comm_icon_xz-guide.svg" />
              </span>
              <span class="app-download-tutorial-text">教程</span>
            </div>
          </div>
        </div>
      </div>
      <!-- 关闭按钮 -->
      <div class="app-download-close" @click="closeAppDownloadPopup">
        <van-icon name="cross" color="#fff" size="24" />
      </div>
    </div>

  </div>
</template>
<script>
import loginNewComponents from "../libs/loginNew.vue";
export default {
  name: 'index',
  components: {
		loginNewComponents,
	},
  data() {
    return {
      hongbashow: true,
      appShow: true,
      current: 0,
      showUserDropdown: false,
      displayNameType: 'username',
      showMorePopup: false,
      morePopupTop: '0px',
      showLangPopup: false,
      showAppDownloadPopup: false,
      isIOS: /iPhone|iPad|iPod/i.test(navigator.userAgent),
      morePopupList: [
        // 第1行
        { id: 1, name: '利息宝', icon: '/static/image/index/menu/menu_1.avif', jumpType: 1, jumpUrl: '/activity', query: { tab: '6' }, status: 1, sort: 1 },
        { id: 2, name: '提现', icon: '/static/image/index/menu/menu_2.avif', jumpType: 1, jumpUrl: '/withdraw', status: 1, sort: 2 },
        { id: 3, name: '存款', icon: '/static/image/index/menu/menu_3.avif', jumpType: 1, jumpUrl: '/recharge', status: 1, sort: 3 },
        { id: 4, name: '活动', icon: '/static/image/index/menu/menu_4.avif', jumpType: 1, jumpUrl: '/activity', query: { tab: '0' }, status: 1, sort: 4 },
        { id: 5, name: '任务', icon: '/static/image/index/menu/menu_5.avif', jumpType: 1, jumpUrl: '/activity', query: { tab: '1' }, status: 1, sort: 5 },
        // 第2行
        { id: 6, name: '返水', icon: '/static/image/index/menu/menu_6.avif', jumpType: 1, jumpUrl: '/activity', query: { tab: '4' }, status: 1, sort: 6 },
        { id: 7, name: '有奖反馈', icon: '/static/image/index/menu/menu_7.avif', jumpType: 1, jumpUrl: '/notice', query: { noticeType: '5', from: 'mine' }, status: 1, sort: 7 },
        { id: 8, name: '安全中心', icon: '/static/image/index/menu/menu_8.avif', jumpType: 1, jumpUrl: '/security', status: 1, sort: 8 },
        { id: 9, name: 'APP下载', icon: '/static/image/index/menu/menu_9.avif', jumpType: 2, action: 'appDownload', status: 1, sort: 9 },
        { id: 10, name: '个人资料', icon: '/static/image/index/menu/menu_10.avif', jumpType: 1, jumpUrl: '/setting', status: 1, sort: 10 },
        // 第3行
        { id: 11, name: '账户明细', icon: '/static/image/index/menu/menu_11.avif', jumpType: 1, jumpUrl: '/money', status: 1, sort: 11 },
        { id: 12, name: '投注记录', icon: '/static/image/index/menu/menu_12.avif', jumpType: 1, jumpUrl: '/report', query: { reportCurrent: '2' }, status: 1, sort: 12 },
        { id: 13, name: '个人报表', icon: '/static/image/index/menu/menu_13.avif', jumpType: 1, jumpUrl: '/report', query: { reportCurrent: '3' }, status: 1, sort: 13 },
        { id: 14, name: '待领取', icon: '/static/image/index/menu/menu_14.avif', jumpType: 1, jumpUrl: '/activity', query: { tab: '5' }, status: 1, sort: 14 },
        { id: 15, name: '提现管理', icon: '/static/image/index/menu/menu_15.avif', jumpType: 1, jumpUrl: '/withdraw', query: { active: '10', from: 'home' }, status: 1, sort: 15 },
        // 第4行
        { id: 16, name: '语言', icon: '/static/image/index/menu/menu_16.avif', jumpType: 2, action: 'language', status: 1, sort: 16 },
        { id: 17, name: '投注任务', icon: '/static/image/index/menu/menu_17.avif', jumpType: 1, jumpUrl: '/activity', query: { tab: '1' }, status: 1, sort: 17 },
        { id: 18, name: '公积金', icon: '/static/image/index/menu/menu_18.avif', jumpType: 1, jumpUrl: '/activity', query: { tab: '8' }, status: 1, sort: 18 },
        { id: 19, name: '领取记录', icon: '/static/image/index/menu/menu_19.avif', jumpType: 1, jumpUrl: '/activity', query: { tab: '7' }, status: 1, sort: 19 },
        { id: 20, name: '立即分享', icon: '/static/image/index/menu/menu_20.avif', jumpType: 2, action: 'share', status: 1, sort: 20 },
        // 第5行
        { id: 21, name: '最近游戏', icon: '/static/image/index/menu/menu_21.avif', jumpType: 1, jumpUrl: '/gameMore', status: 1, sort: 21 },
        { id: 22, name: '收藏游戏', icon: '/static/image/index/menu/menu_22.avif', jumpType: 1, jumpUrl: '/gameMore', status: 1, sort: 22 },
        { id: 23, name: '发现', icon: '/static/image/index/menu/menu_23.avif', jumpType: 1, jumpUrl: '/plazza', status: 1, sort: 23 },
        { id: 24, name: '幸运转盘', icon: '/static/image/index/menu/menu_24.webp', jumpType: 1, jumpUrl: '/activity', query: { tab: '9' }, status: 1, sort: 24 },
        { id: 25, name: '金融SVIP', icon: '/static/image/index/menu/menu_25.avif', jumpType: 1, jumpUrl: '/activity', query: { tab: '2' }, status: 1, sort: 25 },
        // 第6行
        { id: 26, name: '折扣券', icon: '/static/image/index/menu/menu_26.avif', jumpType: 1, jumpUrl: '/coupon', status: 1, sort: 26 },
      ],
      sportsList: [
        {
          time: '07/11 02:00',
          league: '世界杯2026(在...',
          num: '489',
          flag1: '/static/newImg/index/country/01.png',
          flag2: '/static/newImg/index/country/02.png',
          team1: '法国',
          team2: '西班牙',
          odds1: '2.18',
          odds2: '3.41',
          odds3: '3.03'
        },
        {
          time: '07/11 02:00',
          league: '世界杯2026(在...',
          num: '418',
          flag1: '/static/newImg/index/country/03.png',
          flag2: '/static/newImg/index/country/04.png',
          team1: '英格兰',
          team2: '阿根廷',
          odds1: '2.40',
          odds2: '3.04',
          odds3: '2.92'
        }
      ],
      hotGames: [
        { platform_name: 'PG', game_name: 'PG', game_code: 'mahjong1', game_type: 0, mobile_img: '/static/newImg/index/game_hot_01.avif', tag: 'PG' },
        { platform_name: 'PG', game_name: 'PG', game_code: 'mahjong2', game_type: 0, mobile_img: '/static/newImg/index/game_hot_02.avif', tag: 'PG' },
        { platform_name: 'PG', game_name: 'PG', game_code: 'pg_electronic', game_type: 0, mobile_img: '/static/newImg/index/game_hot_03.avif', tag: '热门' },
        { platform_name: 'WG', game_name: 'WG', game_code: 'wg_electronic', game_type: 0, mobile_img: '/static/newImg/index/game_hot_04.avif', tag: '' },
        { platform_name: 'JDB', game_name: 'JDB', game_code: 'jdb_fishing', game_type: 0, mobile_img: '/static/newImg/index/game_hot_05.avif', tag: '' },
        { platform_name: 'PG', game_name: 'PG', game_code: 'beauty_queen', game_type: 0, mobile_img: '/static/newImg/index/game_hot_06.avif', tag: '' },
        { platform_name: 'PG', game_name: 'PG', game_code: 'beauty_knight', game_type: 0, mobile_img: '/static/newImg/index/game_hot_07.avif', tag: '' },
        { platform_name: 'WL', game_name: 'WL', game_code: 'wl_chess', game_type: 0, mobile_img: '/static/newImg/index/game_hot_08.avif', tag: '' },
        { platform_name: 'WG', game_name: 'WG', game_code: 'wg_fishing', game_type: 0, mobile_img: '/static/newImg/index/game_hot_09.avif', tag: '' }
      ],
      activeGameTab: 0,
      gameTopTab: 0,
      // 游戏列表分页展开状态 - 每个section当前显示的游戏数量
      sectionVisibleCount: {
        hot: 9,       // 热门(正好9个,不显示展开按钮)
        electronic: 9,
        card: 9,
        fishing: 9,
        realperson: 9,
        blockchain: 9,
        sport: 9,
        lottery: 9
      },
      bannerList: [],
      bannerAutoplay: 3000, // banner轮播间隔；页面deactivated时置0，防止DOM销毁后定时器仍运行报错
      homenoticelis: [],
      homePaomadeng: null,
      homeUnread: 0,
      // 弹出层
      leftshow: false,
      activeKey: 0,
      gameType: 0,
      tanshow: true,
      appshow: true,
      goInfo: null,
      awardList: [
        {img:'/static/newImg/static/default-award.avif', name:'5***84', bei:53},
        {img:'/static/newImg/static/index/pro/default-hots16.avif', name:'5***84', bei:12},
        {img:'/static/newImg/static/index/pro/default-hots18.avif', name:'5***84', bei:842.00},
        {img:'/static/newImg/static/default-award.avif', name:'5***84', bei:83},
        {img:'/static/newImg/static/index/pro/default-hots21.avif', name:'5***84', bei:63},
        {img:'/static/newImg/static/index/pro/default-hots5.avif', name:'5***84', bei:73},
        {img:'/static/newImg/static/index/pro/default-hots27.avif', name:'5***84', bei:175.00},
        {img:'/static/newImg/static/index/pro/default-hots26.avif', name:'5***84', bei:62},
      ],
      favList: [],
      recentList: [],
      hotsList: [
        {hot: '1', children: [
          {img:'/static/newImg/static/index/pro/default-hots1.avif', name:'CHOICE真人'},
          {img:'/static/newImg/static/index/pro/default-hots2.avif', name:'麻将胡了'},
          {img:'/static/newImg/static/index/pro/default-hots3.avif', name:'麻将胡了2'},
          {img:'/static/newImg/static/index/pro/default-hots4.avif', name:'赏金女王'},
          {img:'/static/newImg/static/index/pro/default-hots5.avif', name:'赏金大对决'},
        ]},
        {hot: '2', children: [
          {img:'/static/newImg/static/index/pro/default-hots6.avif', name:'扑克王国'},
          {img:'/static/newImg/static/index/pro/default-hots7.avif', name:'四大神兽'},
          {img:'/static/newImg/static/index/pro/default-hots8.avif', name:'赏金船长'},
          {img:'/static/newImg/static/index/pro/default-hots9.avif', name:'亡灵大盗'},
          {img:'/static/newImg/static/index/pro/default-hots10.avif', name:'麻将胡了'},
        ]},
        {hot: '3', children: [
          {img:'/static/newImg/static/index/pro/default-hots11.avif', name:'麒麟送宝'},
          {img:'/static/newImg/static/index/pro/default-hots12.avif', name:'招财猫'},
          {img:'/static/newImg/static/index/pro/default-hots13.avif', name:'少林足球'},
          {img:'/static/newImg/static/index/pro/default-hots14.avif', name:'福运象财神'},
          {img:'/static/newImg/static/index/pro/default-hots15.avif', name:'寻宝黄金城'},
        ]},
        {hot: '4', children: [
          {img:'/static/newImg/static/index/pro/default-hots16.avif', name:'糖果派对'},
          {img:'/static/newImg/static/index/pro/default-hots17.avif', name:'财神捕鱼'},
          {img:'/static/newImg/static/index/pro/default-hots18.avif', name:'五龙捕鱼'},
          {img:'/static/newImg/static/index/pro/default-hots19.avif', name:'龙王捕鱼'},
          {img:'/static/newImg/static/index/pro/default-hots20.avif', name:'财神捕鱼'},
        ]},
        {hot: '5', children: [
          {img:'/static/newImg/static/index/pro/default-hots21.avif', name:'捕鱼达人'},
          {img:'/static/newImg/static/index/pro/default-hots22.avif', name:'WL真人'},
          {img:'/static/newImg/static/index/pro/default-hots23.avif', name:'DB真人'},
          {img:'/static/newImg/static/index/pro/default-hots24.avif', name:'视讯极速百家乐'},
          {img:'/static/newImg/static/index/pro/default-hots25.avif', name:'视讯经典百家乐'},
        ]},
      ],
      ssActiveShow: false,
      activePopupList: [
        {img: '/static/newImg/static/index/popup_banner1.avif', title: '粽情端午 登录有礼'},
        {img: '/static/newImg/static/index/popup_banner2.avif', title: '美加墨世界杯'},
        {img: '/static/newImg/static/index/popup_banner3.avif', title: '澳门金沙会员日'},
        {img: '/static/newImg/static/index/popup_banner4.avif', title: '钱包安全 防盗提醒'},
      ],
      loginNewShow: false,
      loginDefaultType: 1,
      sideAdLeftShow: true,
      sideAdRightShow: true,
      sideAdScrolling: false,
      checkinShow: false,
      tipShow: false,
      showRules: true,
      checkinData: {
        consecutiveDays: 0,
        totalClaimed: '0.00',
        needRecharge: '0',
        needBet: '0',
        rechargeThreshold: 300,
        betThreshold: 1500,
        canSign: true,
        days: [
          { reward: '6.00', status: 'current', extra: false },
          { reward: '8.00', status: 'future', extra: false },
          { reward: '10.00', status: 'future', extra: false },
          { reward: '12.00', status: 'future', extra: false },
          { reward: '14.00', status: 'future', extra: true },
          { reward: '16.00', status: 'future', extra: false },
          { reward: '18.00', status: 'future', extra: false },
          { reward: '20.00', status: 'future', extra: false },
          { reward: '22.00', status: 'future', extra: false },
          { reward: '24.00', status: 'future', extra: true },
          { reward: '26.00', status: 'future', extra: false },
          { reward: '28.00', status: 'future', extra: false },
          { reward: '30.00', status: 'future', extra: false },
          { reward: '32.00', status: 'future', extra: false },
          { reward: '36.00', status: 'future', extra: true },
        ],
      },
      checkinDontShowToday: false,
      checkinDontShowAlways: false,
    };
  },
  computed: {
    dropdownStyle() {
      const el = this.$el.querySelector('.user-top');
      if (!el) return {};
      const rect = el.getBoundingClientRect();
      return {
        position: 'fixed',
        top: rect.bottom + 'px',
        left: rect.left + 'px',
      };
    }
  },
  created() {
    let that = this;
    that.getBanList();
    that.homenotice(); //获取公告
    that.loadHotGames(); // 加载热门游戏真实数据
    // 登录后预拉收藏列表（供收藏tab显示 + 本地判断 is_favorite 兜底）
    const token = sessionStorage.getItem('token') || (that.$store && that.$store.state && that.$store.state.token) || '';
    if (token) that.loadFavoriteGames();
    if (token) that.loadRecentGames();
  },
  watch: {
    gameTopTab(val) {
      this.sectionVisibleCount.hot = 9;
      // 切换到收藏tab时，重新拉取收藏列表
      if (Number(val) === 2) {
        const token = sessionStorage.getItem('token') || (this.$store && this.$store.state && this.$store.state.token) || '';
        if (token) this.loadFavoriteGames();
      }
      // 切换到最近tab时，重新拉取最近玩列表
      if (Number(val) === 1) {
        const token = sessionStorage.getItem('token') || (this.$store && this.$store.state && this.$store.state.token) || '';
        if (token) this.loadRecentGames();
      }
    },
    showMorePopup(val) {
      if (val) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
      }
    }
  },
  methods: {
    scrollToGameSection(index) {
      this.activeGameTab = index;
      const section = this.$refs['gameSection' + index];
      const gameContent = this.$refs['gameContent'];
      if (section && gameContent) {
        const offsetTop = section.offsetTop - gameContent.offsetTop;
        gameContent.scrollTo({ top: offsetTop, behavior: 'smooth' });
      }
    },
    // 展开游戏列表 - 每次多显示9条
    expandSection(key, total) {
      const current = this.sectionVisibleCount[key] || 9;
      const next = current + 9;
      this.$set(this.sectionVisibleCount, key, next > total ? total : next);
    },
    // 获取section当前显示的游戏列表（带图片懒加载占位）
    getVisibleGames(list, key) {
      const count = this.sectionVisibleCount[key] || 9;
      const visible = list.slice(0, count);
      // 给每个游戏图片加懒加载属性
      return visible.map(game => ({
        ...game,
        mobile_img: game.mobile_img || '',
        api_logo_img: game.api_logo_img || ''
      }));
    },

    // 加载热门游戏真实数据
    loadHotGames() {
      let that = this;
      that.$apiFun.get('/api/game/category_new', { type: 0 }).then(res => {
        if (res.code === 200 && res.data && res.data.main_games) {
          let list = res.data.main_games || [];
          // 补充字段，保持和模板一致
          list.forEach(el => {
            el.game_name = el.game_name || el.name || el.platform_name || '';
            el.is_favorite = el.is_favorite || 0;
            el.is_hot = el.is_hot || 1;
          });
          localStorage.setItem('hotList', JSON.stringify(list));
          that.$store.commit('changGameList');
        }
      }).catch(err => {
        console.error('loadHotGames error:', err);
      });
    },
    // 游戏卡片点击跳转：主游戏(game_code==0)跳游戏列表页，子游戏保持原跳转
    handleGameClick(item) {
      let that = this;
      // 先拦截登录态，两种跳转都必须登录
      let token = sessionStorage.getItem('token') || that.$store.state.token || '';
      if (!token) {
        that.$parent.showTost(0, '请登录！');
        return;
      }
      let code = String(item.game_code || '').trim();
      if (code === '0') {
        // 主游戏：category_id 映射为 type 1~8
        const cat2type = {
          realbet: 1,
          joker: 2,
          gaming: 3,
          lottery: 4,
          sport: 5,
          concise: 6,
          esports: 7,
          blockchain: 8,
        };
        let t = cat2type[item.category_id];
        if (!t) {
          t = 3; // 兜底：默认电子
        }
        that.$router.push({ name: 'gameList', query: { type: t } });
      } else {
        that.$parent.openGamePage(item.platform_name, item.game_code, '');
      }
    },
    // 点击收藏图标：未登录拦截提示"请先登录"；已登录调用 /api/game/favorite/toggle
    toggleFavorite(item) {
      let that = this;
      let token = sessionStorage.getItem('token') || (that.$store && that.$store.state && that.$store.state.token) || '';
      if (!token) {
        let p = that;
        let showTostFn = null;
        while (p && !showTostFn) {
          if (typeof p.showTost === 'function') { showTostFn = p.showTost.bind(p); }
          else { p = p.$parent; }
        }
        if (showTostFn) { showTostFn(0, '请先登录'); }
        else {
          try { that.$notify({ type: 'warning', message: '请先登录' }); } catch (e) { alert('请先登录'); }
        }
        return;
      }
      // 接口要求传 game_id；优先用 game_id，兜底 id（如果后端后续返回了 id 字段也支持）
      const gameId = Number(item.game_id || item.id || 0);
      if (!gameId) {
        that.showT('缺少游戏ID');
        return;
      }
      // 先乐观翻转，接口失败再回滚
      const oldVal = Number(item.is_favorite || 0);
      item.is_favorite = oldVal ? 0 : 1;
      that.$apiFun.gameFavoriteToggle({ game_id: gameId }).then(res => {
        if (res.code !== 200) {
          // 失败回滚
          item.is_favorite = oldVal;
          that.showT(res.message || '操作失败');
          return;
        }
        const favorited = !!(res.data && res.data.favorited);
        item.is_favorite = favorited ? 1 : 0;
        // 轻量同步：手动增删 favList + localStorage + setFavoriteList
        // 不调 loadFavoriteGames，避免触发接口请求 & 不重置 hotList（防止图标闪回）
        try {
          // 先取当前最新的收藏列表（优先用内存中的 favList，兜底 localStorage）
          let curList = Array.isArray(that.favList) ? that.favList.slice() : [];
          if (curList.length === 0) {
            try {
              const local = localStorage.getItem('favoriteList');
              if (local) curList = JSON.parse(local) || [];
            } catch (e) {}
          }
          if (favorited) {
            // 新增收藏：去重后插入到最前面
            curList = curList.filter(el => Number(el.game_id || el.id) !== gameId);
            const favItem = {
              game_id: gameId,
              id: gameId,
              game_name: item.game_name || item.name || item.platform_name || '',
              game_code: String(item.game_code || ''),
              platform_name: item.platform_name || '',
              api_logo_img: item.api_logo_img || '',
              mobile_img: item.mobile_img || '',
              tag: item.tag || '',
              category_id: item.category_id || '',
              is_favorite: 1,
              is_hot: item.is_hot || 0,
            };
            curList.unshift(favItem);
          } else {
            // 取消收藏：从列表中移除
            curList = curList.filter(el => Number(el.game_id || el.id) !== gameId);
          }
          that.favList = curList;
          localStorage.setItem('favoriteList', JSON.stringify(curList));
          if (that.$store && typeof that.$store.commit === 'function') {
            that.$store.commit('setFavoriteList', curList);
          }
          // 同步 recentList 中的 is_favorite 状态
          try {
            let recentCurList = Array.isArray(that.recentList) ? that.recentList.slice() : [];
            if (recentCurList.length > 0) {
              recentCurList.forEach(el => {
                if (Number(el.game_id) === gameId) {
                  el.is_favorite = favorited ? 1 : 0;
                }
              });
              that.recentList = recentCurList;
              that.$store.commit('setRecentList', recentCurList);
              localStorage.setItem('recentList', JSON.stringify(recentCurList));
            }
          } catch (e) {}
        } catch (e) {
          // 兜底：失败了再走全量刷新
          try { that.loadFavoriteGames(); } catch (x) {}
        }
      }).catch(err => {
        item.is_favorite = oldVal;
        console.error('gameFavoriteToggle error:', err);
        that.showT('网络错误');
      });
    },
    // toast 封装：逐级找 showTost，失败走 notify/alert
    showT(msg, type) {
      let that = this;
      let p = that, fn = null;
      while (p && !fn) { if (typeof p.showTost === 'function') fn = p.showTost.bind(p); else p = p.$parent; }
      if (fn) { fn(type === 0 ? 0 : 0, msg || ''); return; }
      try { that.$notify({ type: 'warning', message: msg }); } catch (e) { try { alert(msg); } catch (x) {} }
    },
    // 登录后从服务端拉取收藏列表，写入 favList / localStorage.favoriteList / store
    loadFavoriteGames() {
      let that = this;
      const token = sessionStorage.getItem('token') || (that.$store && that.$store.state && that.$store.state.token) || '';
      if (!token) return;
      that.$apiFun.gameFavoriteList({ page: 1, page_size: 500 }).then(res => {
        if (res.code !== 200 || !res.data) return;
        const list = Array.isArray(res.data.data) ? res.data.data : [];
        // 补齐字段
        list.forEach(el => {
          el.game_name = el.game_name || el.name || el.platform_name || '';
          el.is_favorite = 1;
          el.is_hot = el.is_hot || 0;
          el.game_id = el.game_id || el.id || 0;
        });
        that.favList = list;
        try { localStorage.setItem('favoriteList', JSON.stringify(list)); } catch (e) {}
        try {
          // 使用 setFavoriteList 只更新收藏列表（不重置 hotList，避免收藏图标闪回）
          if (typeof that.$store.commit === 'function') that.$store.commit('setFavoriteList', list);
        } catch (e) {}
      }).catch(err => {
        console.error('loadFavoriteGames error:', err);
      });
    },
    // 登录后从服务端拉取最近玩列表，写入 recentList / localStorage.recentList / store
    loadRecentGames() {
      let that = this;
      const token = sessionStorage.getItem('token') || (that.$store && that.$store.state && that.$store.state.token) || '';
      if (!token) return;
      that.$apiFun.gameRecentList({}).then(res => {
        if (res.code !== 200 || !res.data) return;
        const list = Array.isArray(res.data.data) ? res.data.data : [];
        list.forEach(el => {
          el.game_name = el.game_name || el.platform_name || '';
          el.is_favorite = Number(el.is_favorite || 0);
          el.game_id = Number(el.game_id || 0);
        });
        that.recentList = list;
        try { localStorage.setItem('recentList', JSON.stringify(list)); } catch (e) {}
        try {
          if (typeof that.$store.commit === 'function') that.$store.commit('setRecentList', list);
        } catch (e) {}
      }).catch(err => {
        console.error('loadRecentGames error:', err);
      });
    },
    // 注入模拟游戏数据到store
    injectMockGameData() {
      // 热门游戏数据 - 89条
      const hotGames = [
        { id: 86, game_code: '65', game_type: 3, platform_name: 'PGA', game_name: '麻将胡了', category_id: 'hot', category_name: '热门', mobile_img: '/static/newImg/index/game/remen/麻将胡了.avif', app_state: 1, is_hot: 1, is_recent: 0, is_favorite: 0, has_name: 0, sort_order: 86 },
        { id: 87, game_code: '74', game_type: 3, platform_name: 'PGA', game_name: '麻将胡了2', category_id: 'hot', category_name: '热门', mobile_img: '/static/newImg/index/game/remen/麻将胡了2.avif', app_state: 1, is_hot: 1, is_recent: 0, is_favorite: 0, has_name: 0, sort_order: 87 },
        { id: 84, game_code: '84', game_type: 3, platform_name: 'PGA', game_name: '赏金女王', category_id: 'hot', category_name: '热门', mobile_img: '/static/newImg/index/game/remen/赏金女王.avif', app_state: 1, is_hot: 1, is_recent: 0, is_favorite: 0, has_name: 0, sort_order: 84 },
        { id: 83, game_code: '135', game_type: 3, platform_name: 'PGA', game_name: '赏金大对决', category_id: 'hot', category_name: '热门', mobile_img: '/static/newImg/index/game/remen/赏金大对决.avif', app_state: 1, is_hot: 1, is_recent: 0, is_favorite: 0, has_name: 0, sort_order: 83 },
        { id: 85, game_code: '54', game_type: 3, platform_name: 'PG', game_name: '赏金船长', category_id: 'hot', category_name: '热门', mobile_img: '/static/newImg/index/game/remen/赏金船长.avif', app_state: 1, is_hot: 1, is_recent: 0, is_favorite: 0, has_name: 0, sort_order: 85 },
        { id: 34, game_code: '600', game_type: 6, platform_name: 'KY', game_name: 'KY21点', category_id: 'hot', category_name: '热门', mobile_img: '/static/newImg/index/game/remen/KY21点.avif', app_state: 1, is_hot: 1, is_recent: 0, is_favorite: 0, has_name: 0, sort_order: 34 },
        { id: 35, game_code: '830', game_type: 6, platform_name: 'KY', game_name: 'KY抢庄牛牛', category_id: 'hot', category_name: '热门', mobile_img: '/static/newImg/index/game/remen/KY抢庄牛牛.avif', app_state: 1, is_hot: 1, is_recent: 0, is_favorite: 0, has_name: 0, sort_order: 35 },
        { id: 82, game_code: '7003', game_type: 2, platform_name: 'JDB', game_name: '财神捕鱼', category_id: 'hot', category_name: '热门', mobile_img: '/static/newImg/index/game/remen/财神捕鱼.avif', app_state: 1, is_hot: 1, is_recent: 0, is_favorite: 0, has_name: 0, sort_order: 82 },
        { id: 1, game_code: 'hot_1', game_type: 0, platform_name: 'BBIN彩票', game_name: 'BBIN彩票', category_id: 'hot', category_name: '热门', mobile_img: '/static/newImg/index/game/remen/BBIN彩票.avif', app_state: 1, is_hot: 1, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 1 },
        { id: 2, game_code: 'hot_2', game_type: 0, platform_name: 'BBIN捕鱼', game_name: 'BBIN捕鱼', category_id: 'hot', category_name: '热门', mobile_img: '/static/newImg/index/game/remen/BBIN捕鱼.avif', app_state: 1, is_hot: 1, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 2 },
        { id: 3, game_code: 'hot_3', game_type: 0, platform_name: 'BBIN电子', game_name: 'BBIN电子', category_id: 'hot', category_name: '热门', mobile_img: '/static/newImg/index/game/remen/BBIN电子.avif', app_state: 1, is_hot: 1, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 3 },
        { id: 4, game_code: 'hot_4', game_type: 0, platform_name: 'BBIN真人', game_name: 'BBIN真人', category_id: 'hot', category_name: '热门', mobile_img: '/static/newImg/index/game/remen/BBIN真人.avif', app_state: 1, is_hot: 1, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 4 },
        { id: 5, game_code: 'hot_5', game_type: 0, platform_name: 'BBIN糖果派对-极速版', game_name: 'BBIN糖果派对-极速版', category_id: 'hot', category_name: '热门', mobile_img: '/static/newImg/index/game/remen/BBIN糖果派对-极速版.avif', app_state: 1, is_hot: 1, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 5 },
        { id: 6, game_code: 'hot_6', game_type: 0, platform_name: 'BBIN糖果派对', game_name: 'BBIN糖果派对', category_id: 'hot', category_name: '热门', mobile_img: '/static/newImg/index/game/remen/BBIN糖果派对.avif', app_state: 1, is_hot: 1, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 6 },
        { id: 7, game_code: 'hot_7', game_type: 0, platform_name: 'BBIN糖果派对2', game_name: 'BBIN糖果派对2', category_id: 'hot', category_name: '热门', mobile_img: '/static/newImg/index/game/remen/BBIN糖果派对2.avif', app_state: 1, is_hot: 1, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 7 },
        { id: 8, game_code: 'hot_8', game_type: 0, platform_name: 'BBIN糖果派对3', game_name: 'BBIN糖果派对3', category_id: 'hot', category_name: '热门', mobile_img: '/static/newImg/index/game/remen/BBIN糖果派对3.avif', app_state: 1, is_hot: 1, is_recent: 0, is_favorite: 0, has_name: 0, sort_order: 8 },
        { id: 9, game_code: 'hot_9', game_type: 0, platform_name: 'BG捕鱼', game_name: 'BG捕鱼', category_id: 'hot', category_name: '热门', mobile_img: '/static/newImg/index/game/remen/BG捕鱼.avif', app_state: 1, is_hot: 1, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 9 },
        { id: 10, game_code: 'hot_10', game_type: 0, platform_name: 'BG真人', game_name: 'BG真人', category_id: 'hot', category_name: '热门', mobile_img: '/static/newImg/index/game/remen/BG真人.avif', app_state: 1, is_hot: 1, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 10 },
        { id: 11, game_code: 'hot_11', game_type: 0, platform_name: 'BS捕鱼', game_name: 'BS捕鱼', category_id: 'hot', category_name: '热门', mobile_img: '/static/newImg/index/game/remen/BS捕鱼.avif', app_state: 1, is_hot: 1, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 11 },
        { id: 12, game_code: 'hot_12', game_type: 0, platform_name: 'BS棋牌', game_name: 'BS棋牌', category_id: 'hot', category_name: '热门', mobile_img: '/static/newImg/index/game/remen/BS棋牌.avif', app_state: 1, is_hot: 1, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 12 },
        { id: 13, game_code: 'hot_13', game_type: 0, platform_name: 'CHOICE捕鱼', game_name: 'CHOICE捕鱼', category_id: 'hot', category_name: '热门', mobile_img: '/static/newImg/index/game/remen/CHOICE捕鱼.avif', app_state: 1, is_hot: 1, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 13 },
        { id: 14, game_code: 'hot_14', game_type: 0, platform_name: 'CHOICE电子', game_name: 'CHOICE电子', category_id: 'hot', category_name: '热门', mobile_img: '/static/newImg/index/game/remen/CHOICE电子.avif', app_state: 1, is_hot: 1, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 14 },
        { id: 15, game_code: 'hot_15', game_type: 0, platform_name: 'CHOICE真人', game_name: 'CHOICE真人', category_id: 'hot', category_name: '热门', mobile_img: '/static/newImg/index/game/remen/CHOICE真人.avif', app_state: 1, is_hot: 1, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 15 },
        { id: 16, game_code: 'hot_16', game_type: 0, platform_name: 'CQ9捕鱼', game_name: 'CQ9捕鱼', category_id: 'hot', category_name: '热门', mobile_img: '/static/newImg/index/game/remen/CQ9捕鱼.avif', app_state: 1, is_hot: 1, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 16 },
        { id: 17, game_code: 'hot_17', game_type: 0, platform_name: 'CQ9电子', game_name: 'CQ9电子', category_id: 'hot', category_name: '热门', mobile_img: '/static/newImg/index/game/remen/CQ9电子.avif', app_state: 1, is_hot: 1, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 17 },
        { id: 18, game_code: 'hot_18', game_type: 0, platform_name: 'CQ9跳更高', game_name: 'CQ9跳更高', category_id: 'hot', category_name: '热门', mobile_img: '/static/newImg/index/game/remen/CQ9跳更高.avif', app_state: 1, is_hot: 1, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 18 },
        { id: 19, game_code: 'hot_19', game_type: 0, platform_name: 'CQ9跳起来', game_name: 'CQ9跳起来', category_id: 'hot', category_name: '热门', mobile_img: '/static/newImg/index/game/remen/CQ9跳起来.avif', app_state: 1, is_hot: 1, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 19 },
        { id: 20, game_code: 'hot_20', game_type: 0, platform_name: 'CQ9跳高高', game_name: 'CQ9跳高高', category_id: 'hot', category_name: '热门', mobile_img: '/static/newImg/index/game/remen/CQ9跳高高.avif', app_state: 1, is_hot: 1, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 20 },
        { id: 21, game_code: 'hot_21', game_type: 0, platform_name: 'DB真人', game_name: 'DB真人', category_id: 'hot', category_name: '热门', mobile_img: '/static/newImg/index/game/remen/DB真人.avif', app_state: 1, is_hot: 1, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 21 },
        { id: 22, game_code: 'hot_22', game_type: 0, platform_name: 'FC捕鱼', game_name: 'FC捕鱼', category_id: 'hot', category_name: '热门', mobile_img: '/static/newImg/index/game/remen/FC捕鱼.avif', app_state: 1, is_hot: 1, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 22 },
        { id: 23, game_code: 'hot_23', game_type: 0, platform_name: 'FC电子', game_name: 'FC电子', category_id: 'hot', category_name: '热门', mobile_img: '/static/newImg/index/game/remen/FC电子.avif', app_state: 1, is_hot: 1, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 23 },
        { id: 24, game_code: 'hot_24', game_type: 0, platform_name: 'FG棋牌', game_name: 'FG棋牌', category_id: 'hot', category_name: '热门', mobile_img: '/static/newImg/index/game/remen/FG棋牌.avif', app_state: 1, is_hot: 1, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 24 },
        { id: 25, game_code: 'hot_25', game_type: 0, platform_name: 'FG电子', game_name: 'FG电子', category_id: 'hot', category_name: '热门', mobile_img: '/static/newImg/index/game/remen/FG电子.avif', app_state: 1, is_hot: 1, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 25 },
        { id: 26, game_code: 'hot_26', game_type: 0, platform_name: 'IM体育', game_name: 'IM体育', category_id: 'hot', category_name: '热门', mobile_img: '/static/newImg/index/game/remen/IM体育.avif', app_state: 1, is_hot: 1, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 26 },
        { id: 27, game_code: 'hot_27', game_type: 0, platform_name: 'JDB三倍金刚', game_name: 'JDB三倍金刚', category_id: 'hot', category_name: '热门', mobile_img: '/static/newImg/index/game/remen/JDB三倍金刚.avif', app_state: 1, is_hot: 1, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 27 },
        { id: 28, game_code: 'hot_28', game_type: 0, platform_name: 'JDB五龙捕鱼', game_name: 'JDB五龙捕鱼', category_id: 'hot', category_name: '热门', mobile_img: '/static/newImg/index/game/remen/JDB五龙捕鱼.avif', app_state: 1, is_hot: 1, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 28 },
        { id: 29, game_code: 'hot_29', game_type: 0, platform_name: 'JDB变脸', game_name: 'JDB变脸', category_id: 'hot', category_name: '热门', mobile_img: '/static/newImg/index/game/remen/JDB变脸.avif', app_state: 1, is_hot: 1, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 29 },
        { id: 30, game_code: 'hot_30', game_type: 0, platform_name: 'JDB捕鱼', game_name: 'JDB捕鱼', category_id: 'hot', category_name: '热门', mobile_img: '/static/newImg/index/game/remen/JDB捕鱼.avif', app_state: 1, is_hot: 1, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 30 },
        { id: 31, game_code: 'hot_31', game_type: 0, platform_name: 'JDB电子', game_name: 'JDB电子', category_id: 'hot', category_name: '热门', mobile_img: '/static/newImg/index/game/remen/JDB电子.avif', app_state: 1, is_hot: 1, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 31 },
        { id: 32, game_code: 'hot_32', game_type: 0, platform_name: 'JDB芝麻开门', game_name: 'JDB芝麻开门', category_id: 'hot', category_name: '热门', mobile_img: '/static/newImg/index/game/remen/JDB芝麻开门.avif', app_state: 1, is_hot: 1, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 32 },
        { id: 33, game_code: 'hot_33', game_type: 0, platform_name: 'JDB飞鸟派对', game_name: 'JDB飞鸟派对', category_id: 'hot', category_name: '热门', mobile_img: '/static/newImg/index/game/remen/JDB飞鸟派对.avif', app_state: 1, is_hot: 1, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 33 },
        { id: 36, game_code: 'hot_36', game_type: 0, platform_name: 'KY押庄龙虎', game_name: 'KY押庄龙虎', category_id: 'hot', category_name: '热门', mobile_img: '/static/newImg/index/game/remen/KY押庄龙虎.avif', app_state: 1, is_hot: 1, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 36 },
        { id: 37, game_code: 'hot_37', game_type: 0, platform_name: 'KY极速炸金花', game_name: 'KY极速炸金花', category_id: 'hot', category_name: '热门', mobile_img: '/static/newImg/index/game/remen/KY极速炸金花.avif', app_state: 1, is_hot: 1, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 37 },
        { id: 38, game_code: 'hot_38', game_type: 0, platform_name: 'KY看牌抢庄牛牛', game_name: 'KY看牌抢庄牛牛', category_id: 'hot', category_name: '热门', mobile_img: '/static/newImg/index/game/remen/KY看牌抢庄牛牛.avif', app_state: 1, is_hot: 1, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 38 },
        { id: 39, game_code: 'hot_39', game_type: 0, platform_name: 'KY通比牛牛', game_name: 'KY通比牛牛', category_id: 'hot', category_name: '热门', mobile_img: '/static/newImg/index/game/remen/KY通比牛牛.avif', app_state: 1, is_hot: 1, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 39 },
        { id: 40, game_code: 'hot_40', game_type: 0, platform_name: 'LEG棋牌', game_name: 'LEG棋牌', category_id: 'hot', category_name: '热门', mobile_img: '/static/newImg/index/game/remen/LEG棋牌.avif', app_state: 1, is_hot: 1, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 40 },
        { id: 41, game_code: 'hot_41', game_type: 0, platform_name: 'LEG金鲨银鲨', game_name: 'LEG金鲨银鲨', category_id: 'hot', category_name: '热门', mobile_img: '/static/newImg/index/game/remen/LEG金鲨银鲨.avif', app_state: 1, is_hot: 1, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 41 },
        { id: 42, game_code: 'hot_42', game_type: 0, platform_name: 'MG冰球突破', game_name: 'MG冰球突破', category_id: 'hot', category_name: '热门', mobile_img: '/static/newImg/index/game/remen/MG冰球突破.avif', app_state: 1, is_hot: 1, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 42 },
        { id: 43, game_code: 'hot_43', game_type: 0, platform_name: 'MG冰球突破豪华版', game_name: 'MG冰球突破豪华版', category_id: 'hot', category_name: '热门', mobile_img: '/static/newImg/index/game/remen/MG冰球突破豪华版.avif', app_state: 1, is_hot: 1, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 43 },
        { id: 44, game_code: 'hot_44', game_type: 0, platform_name: 'MG淑女派对', game_name: 'MG淑女派对', category_id: 'hot', category_name: '热门', mobile_img: '/static/newImg/index/game/remen/MG淑女派对.avif', app_state: 1, is_hot: 1, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 44 },
        { id: 45, game_code: 'hot_45', game_type: 0, platform_name: 'MG电子', game_name: 'MG电子', category_id: 'hot', category_name: '热门', mobile_img: '/static/newImg/index/game/remen/MG电子.avif', app_state: 1, is_hot: 1, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 45 },
        { id: 46, game_code: 'hot_46', game_type: 0, platform_name: 'MG花花公子', game_name: 'MG花花公子', category_id: 'hot', category_name: '热门', mobile_img: '/static/newImg/index/game/remen/MG花花公子.avif', app_state: 1, is_hot: 1, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 46 },
        { id: 47, game_code: 'hot_47', game_type: 0, platform_name: 'PG亡灵大盗', game_name: 'PG亡灵大盗', category_id: 'hot', category_name: '热门', mobile_img: '/static/newImg/index/game/remen/PG亡灵大盗.avif', app_state: 1, is_hot: 1, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 47 },
        { id: 48, game_code: 'hot_48', game_type: 0, platform_name: 'PG十倍金牛', game_name: 'PG十倍金牛', category_id: 'hot', category_name: '热门', mobile_img: '/static/newImg/index/game/remen/PG十倍金牛.avif', app_state: 1, is_hot: 1, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 48 },
        { id: 49, game_code: 'hot_49', game_type: 0, platform_name: 'PG双囍临门', game_name: 'PG双囍临门', category_id: 'hot', category_name: '热门', mobile_img: '/static/newImg/index/game/remen/PG双囍临门.avif', app_state: 1, is_hot: 1, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 49 },
        { id: 50, game_code: 'hot_50', game_type: 0, platform_name: 'PG夜醉佳人', game_name: 'PG夜醉佳人', category_id: 'hot', category_name: '热门', mobile_img: '/static/newImg/index/game/remen/PG夜醉佳人.avif', app_state: 1, is_hot: 1, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 50 },
        { id: 51, game_code: 'hot_51', game_type: 0, platform_name: 'PG宝石传奇', game_name: 'PG宝石传奇', category_id: 'hot', category_name: '热门', mobile_img: '/static/newImg/index/game/remen/PG宝石传奇.avif', app_state: 1, is_hot: 1, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 51 },
        { id: 52, game_code: 'hot_52', game_type: 0, platform_name: 'PG少林足球', game_name: 'PG少林足球', category_id: 'hot', category_name: '热门', mobile_img: '/static/newImg/index/game/remen/PG少林足球.avif', app_state: 1, is_hot: 1, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 52 },
        { id: 53, game_code: 'hot_53', game_type: 0, platform_name: 'PG快钱来了', game_name: 'PG快钱来了', category_id: 'hot', category_name: '热门', mobile_img: '/static/newImg/index/game/remen/PG快钱来了.avif', app_state: 1, is_hot: 1, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 53 },
        { id: 54, game_code: 'hot_54', game_type: 0, platform_name: 'PG恐龙帝国', game_name: 'PG恐龙帝国', category_id: 'hot', category_name: '热门', mobile_img: '/static/newImg/index/game/remen/PG恐龙帝国.avif', app_state: 1, is_hot: 1, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 54 },
        { id: 55, game_code: 'hot_55', game_type: 0, platform_name: 'PG招财喵', game_name: 'PG招财喵', category_id: 'hot', category_name: '热门', mobile_img: '/static/newImg/index/game/remen/PG招财喵.avif', app_state: 1, is_hot: 1, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 55 },
        { id: 56, game_code: 'hot_56', game_type: 0, platform_name: 'PG澳门壕梦', game_name: 'PG澳门壕梦', category_id: 'hot', category_name: '热门', mobile_img: '/static/newImg/index/game/remen/PG澳门壕梦.avif', app_state: 1, is_hot: 1, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 56 },
        { id: 57, game_code: 'hot_57', game_type: 0, platform_name: 'PG火树赢花', game_name: 'PG火树赢花', category_id: 'hot', category_name: '热门', mobile_img: '/static/newImg/index/game/remen/PG火树赢花.avif', app_state: 1, is_hot: 1, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 57 },
        { id: 58, game_code: 'hot_58', game_type: 0, platform_name: 'PG爱尔兰精灵', game_name: 'PG爱尔兰精灵', category_id: 'hot', category_name: '热门', mobile_img: '/static/newImg/index/game/remen/PG爱尔兰精灵.avif', app_state: 1, is_hot: 1, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 58 },
        { id: 59, game_code: 'hot_59', game_type: 0, platform_name: 'PG电子', game_name: 'PG电子', category_id: 'hot', category_name: '热门', mobile_img: '/static/newImg/index/game/remen/PG电子.avif', app_state: 1, is_hot: 1, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 59 },
        { id: 60, game_code: 'hot_60', game_type: 0, platform_name: 'PG福运象财神', game_name: 'PG福运象财神', category_id: 'hot', category_name: '热门', mobile_img: '/static/newImg/index/game/remen/PG福运象财神.avif', app_state: 1, is_hot: 1, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 60 },
        { id: 61, game_code: 'hot_61', game_type: 0, platform_name: 'PG金钱兔', game_name: 'PG金钱兔', category_id: 'hot', category_name: '热门', mobile_img: '/static/newImg/index/game/remen/PG金钱兔.avif', app_state: 1, is_hot: 1, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 61 },
        { id: 62, game_code: 'hot_62', game_type: 0, platform_name: 'PG麒麟送宝', game_name: 'PG麒麟送宝', category_id: 'hot', category_name: '热门', mobile_img: '/static/newImg/index/game/remen/PG麒麟送宝.avif', app_state: 1, is_hot: 1, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 62 },
        { id: 63, game_code: 'hot_63', game_type: 0, platform_name: 'PP电子', game_name: 'PP电子', category_id: 'hot', category_name: '热门', mobile_img: '/static/newImg/index/game/remen/PP电子.avif', app_state: 1, is_hot: 1, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 63 },
        { id: 64, game_code: 'hot_64', game_type: 0, platform_name: 'WG体育', game_name: 'WG体育', category_id: 'hot', category_name: '热门', mobile_img: '/static/newImg/index/game/remen/WG体育.avif', app_state: 1, is_hot: 1, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 64 },
        { id: 65, game_code: 'hot_65', game_type: 0, platform_name: 'WG抢庄牛牛', game_name: 'WG抢庄牛牛', category_id: 'hot', category_name: '热门', mobile_img: '/static/newImg/index/game/remen/WG抢庄牛牛.avif', app_state: 1, is_hot: 1, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 65 },
        { id: 66, game_code: 'hot_66', game_type: 0, platform_name: 'WG捕鱼', game_name: 'WG捕鱼', category_id: 'hot', category_name: '热门', mobile_img: '/static/newImg/index/game/remen/WG捕鱼.avif', app_state: 1, is_hot: 1, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 66 },
        { id: 67, game_code: 'hot_67', game_type: 0, platform_name: 'WG捕鱼达人', game_name: 'WG捕鱼达人', category_id: 'hot', category_name: '热门', mobile_img: '/static/newImg/index/game/remen/WG捕鱼达人.avif', app_state: 1, is_hot: 1, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 67 },
        { id: 68, game_code: 'hot_68', game_type: 0, platform_name: 'WG棋牌', game_name: 'WG棋牌', category_id: 'hot', category_name: '热门', mobile_img: '/static/newImg/index/game/remen/WG棋牌.avif', app_state: 1, is_hot: 1, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 68 },
        { id: 69, game_code: 'hot_69', game_type: 0, platform_name: 'WG炸金花', game_name: 'WG炸金花', category_id: 'hot', category_name: '热门', mobile_img: '/static/newImg/index/game/remen/WG炸金花.avif', app_state: 1, is_hot: 1, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 69 },
        { id: 70, game_code: 'hot_70', game_type: 0, platform_name: 'WG电子', game_name: 'WG电子', category_id: 'hot', category_name: '热门', mobile_img: '/static/newImg/index/game/remen/WG电子.avif', app_state: 1, is_hot: 1, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 70 },
        { id: 71, game_code: 'hot_71', game_type: 0, platform_name: 'WG红黑大战', game_name: 'WG红黑大战', category_id: 'hot', category_name: '热门', mobile_img: '/static/newImg/index/game/remen/WG红黑大战.avif', app_state: 1, is_hot: 1, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 71 },
        { id: 72, game_code: 'hot_72', game_type: 0, platform_name: 'WG财神捕鱼', game_name: 'WG财神捕鱼', category_id: 'hot', category_name: '热门', mobile_img: '/static/newImg/index/game/remen/WG财神捕鱼.avif', app_state: 1, is_hot: 1, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 72 },
        { id: 73, game_code: 'hot_73', game_type: 0, platform_name: 'WL捕鱼', game_name: 'WL捕鱼', category_id: 'hot', category_name: '热门', mobile_img: '/static/newImg/index/game/remen/WL捕鱼.avif', app_state: 1, is_hot: 1, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 73 },
        { id: 74, game_code: 'hot_74', game_type: 0, platform_name: 'WL棋牌', game_name: 'WL棋牌', category_id: 'hot', category_name: '热门', mobile_img: '/static/newImg/index/game/remen/WL棋牌.avif', app_state: 1, is_hot: 1, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 74 },
        { id: 75, game_code: 'hot_75', game_type: 0, platform_name: 'WL真人', game_name: 'WL真人', category_id: 'hot', category_name: '热门', mobile_img: '/static/newImg/index/game/remen/WL真人.avif', app_state: 1, is_hot: 1, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 75 },
        { id: 76, game_code: 'hot_76', game_type: 0, platform_name: 'YGR捕鱼', game_name: 'YGR捕鱼', category_id: 'hot', category_name: '热门', mobile_img: '/static/newImg/index/game/remen/YGR捕鱼.avif', app_state: 1, is_hot: 1, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 76 },
        { id: 77, game_code: 'hot_77', game_type: 0, platform_name: '寻宝黄金城', game_name: '寻宝黄金城', category_id: 'hot', category_name: '热门', mobile_img: '/static/newImg/index/game/remen/寻宝黄金城.avif', app_state: 1, is_hot: 1, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 77 },
        { id: 78, game_code: 'hot_78', game_type: 0, platform_name: '开元捕鱼', game_name: '开元捕鱼', category_id: 'hot', category_name: '热门', mobile_img: '/static/newImg/index/game/remen/开元捕鱼.avif', app_state: 1, is_hot: 1, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 78 },
        { id: 79, game_code: 'hot_79', game_type: 0, platform_name: '开元棋牌', game_name: '开元棋牌', category_id: 'hot', category_name: '热门', mobile_img: '/static/newImg/index/game/remen/开元棋牌.avif', app_state: 1, is_hot: 1, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 79 },
        { id: 80, game_code: 'hot_80', game_type: 0, platform_name: '明日派对', game_name: '明日派对', category_id: 'hot', category_name: '热门', mobile_img: '/static/newImg/index/game/remen/明日派对.avif', app_state: 1, is_hot: 1, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 80 },
        { id: 81, game_code: 'hot_81', game_type: 0, platform_name: '氮能夺宝', game_name: '氮能夺宝', category_id: 'hot', category_name: '热门', mobile_img: '/static/newImg/index/game/remen/氮能夺宝.avif', app_state: 1, is_hot: 1, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 81 },
        { id: 88, game_code: 'hot_88', game_type: 0, platform_name: '龙之连环-喜悦富足', game_name: '龙之连环-喜悦富足', category_id: 'hot', category_name: '热门', mobile_img: '/static/newImg/index/game/remen/龙之连环-喜悦富足.avif', app_state: 1, is_hot: 1, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 88 },
        { id: 89, game_code: 'hot_89', game_type: 0, platform_name: '龙之连环-黄金盛世', game_name: '龙之连环-黄金盛世', category_id: 'hot', category_name: '热门', mobile_img: '/static/newImg/index/game/remen/龙之连环-黄金盛世.avif', app_state: 1, is_hot: 1, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 89 }
      ];

      // 电子游戏数据 - 29条
      const realbetList = [
        { id: 90, game_code: 'electronic_1', game_type: 0, platform_name: '168Game电子', game_name: '168Game电子', category_id: 'realbet', category_name: '电子', mobile_img: '/static/newImg/index/game/dianzi/168Game电子.avif', app_state: 1, is_hot: 0, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 1 },
        { id: 91, game_code: 'electronic_2', game_type: 0, platform_name: 'BBIN电子', game_name: 'BBIN电子', category_id: 'realbet', category_name: '电子', mobile_img: '/static/newImg/index/game/dianzi/BBIN电子.avif', app_state: 1, is_hot: 0, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 2 },
        { id: 92, game_code: 'electronic_3', game_type: 0, platform_name: 'BNG电子', game_name: 'BNG电子', category_id: 'realbet', category_name: '电子', mobile_img: '/static/newImg/index/game/dianzi/BNG电子.avif', app_state: 1, is_hot: 0, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 3 },
        { id: 93, game_code: 'electronic_4', game_type: 0, platform_name: 'BTG电子', game_name: 'BTG电子', category_id: 'realbet', category_name: '电子', mobile_img: '/static/newImg/index/game/dianzi/BTG电子.avif', app_state: 1, is_hot: 0, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 4 },
        { id: 94, game_code: 'electronic_5', game_type: 0, platform_name: 'CHOICE电子', game_name: 'CHOICE电子', category_id: 'realbet', category_name: '电子', mobile_img: '/static/newImg/index/game/dianzi/CHOICE电子.avif', app_state: 1, is_hot: 0, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 5 },
        { id: 95, game_code: 'electronic_6', game_type: 0, platform_name: 'CQ9电子', game_name: 'CQ9电子', category_id: 'realbet', category_name: '电子', mobile_img: '/static/newImg/index/game/dianzi/CQ9电子.avif', app_state: 1, is_hot: 0, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 6 },
        { id: 96, game_code: 'electronic_7', game_type: 0, platform_name: 'DB电子', game_name: 'DB电子', category_id: 'realbet', category_name: '电子', mobile_img: '/static/newImg/index/game/dianzi/DB电子.avif', app_state: 1, is_hot: 0, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 7 },
        { id: 97, game_code: 'electronic_8', game_type: 0, platform_name: 'DS电子', game_name: 'DS电子', category_id: 'realbet', category_name: '电子', mobile_img: '/static/newImg/index/game/dianzi/DS电子.avif', app_state: 1, is_hot: 0, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 8 },
        { id: 98, game_code: 'electronic_9', game_type: 0, platform_name: 'FC电子', game_name: 'FC电子', category_id: 'realbet', category_name: '电子', mobile_img: '/static/newImg/index/game/dianzi/FC电子.avif', app_state: 1, is_hot: 0, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 9 },
        { id: 99, game_code: 'electronic_10', game_type: 0, platform_name: 'FG电子', game_name: 'FG电子', category_id: 'realbet', category_name: '电子', mobile_img: '/static/newImg/index/game/dianzi/FG电子.avif', app_state: 1, is_hot: 0, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 10 },
        { id: 100, game_code: 'electronic_11', game_type: 0, platform_name: 'HB电子', game_name: 'HB电子', category_id: 'realbet', category_name: '电子', mobile_img: '/static/newImg/index/game/dianzi/HB电子.avif', app_state: 1, is_hot: 0, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 11 },
        { id: 101, game_code: 'electronic_12', game_type: 0, platform_name: 'JDB电子', game_name: 'JDB电子', category_id: 'realbet', category_name: '电子', mobile_img: '/static/newImg/index/game/dianzi/JDB电子.avif', app_state: 1, is_hot: 0, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 12 },
        { id: 102, game_code: 'electronic_13', game_type: 0, platform_name: 'JILI电子', game_name: 'JILI电子', category_id: 'realbet', category_name: '电子', mobile_img: '/static/newImg/index/game/dianzi/JILI电子.avif', app_state: 1, is_hot: 0, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 13 },
        { id: 103, game_code: 'electronic_14', game_type: 0, platform_name: 'LG电子', game_name: 'LG电子', category_id: 'realbet', category_name: '电子', mobile_img: '/static/newImg/index/game/dianzi/LG电子.avif', app_state: 1, is_hot: 0, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 14 },
        { id: 104, game_code: 'electronic_15', game_type: 0, platform_name: 'MarbleX电子', game_name: 'MarbleX电子', category_id: 'realbet', category_name: '电子', mobile_img: '/static/newImg/index/game/dianzi/MarbleX电子.avif', app_state: 1, is_hot: 0, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 15 },
        { id: 105, game_code: 'electronic_16', game_type: 0, platform_name: 'MG电子', game_name: 'MG电子', category_id: 'realbet', category_name: '电子', mobile_img: '/static/newImg/index/game/dianzi/MG电子.avif', app_state: 1, is_hot: 0, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 16 },
        { id: 106, game_code: 'electronic_17', game_type: 0, platform_name: 'Nolimitcity电子', game_name: 'Nolimitcity电子', category_id: 'realbet', category_name: '电子', mobile_img: '/static/newImg/index/game/dianzi/Nolimitcity电子.avif', app_state: 1, is_hot: 0, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 17 },
        { id: 107, game_code: 'electronic_18', game_type: 0, platform_name: 'PG电子', game_name: 'PG电子', category_id: 'realbet', category_name: '电子', mobile_img: '/static/newImg/index/game/dianzi/PG电子.avif', app_state: 1, is_hot: 0, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 18 },
        { id: 108, game_code: 'electronic_19', game_type: 0, platform_name: 'PP电子', game_name: 'PP电子', category_id: 'realbet', category_name: '电子', mobile_img: '/static/newImg/index/game/dianzi/PP电子.avif', app_state: 1, is_hot: 0, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 19 },
        { id: 109, game_code: 'electronic_20', game_type: 0, platform_name: 'PS电子', game_name: 'PS电子', category_id: 'realbet', category_name: '电子', mobile_img: '/static/newImg/index/game/dianzi/PS电子.avif', app_state: 1, is_hot: 0, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 20 },
        { id: 110, game_code: 'electronic_21', game_type: 0, platform_name: 'PT电子', game_name: 'PT电子', category_id: 'realbet', category_name: '电子', mobile_img: '/static/newImg/index/game/dianzi/PT电子.avif', app_state: 1, is_hot: 0, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 21 },
        { id: 111, game_code: 'electronic_22', game_type: 0, platform_name: 'RSG电子', game_name: 'RSG电子', category_id: 'realbet', category_name: '电子', mobile_img: '/static/newImg/index/game/dianzi/RSG电子.avif', app_state: 1, is_hot: 0, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 22 },
        { id: 112, game_code: 'electronic_23', game_type: 0, platform_name: 'V8电子', game_name: 'V8电子', category_id: 'realbet', category_name: '电子', mobile_img: '/static/newImg/index/game/dianzi/V8电子.avif', app_state: 1, is_hot: 0, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 23 },
        { id: 113, game_code: 'electronic_24', game_type: 0, platform_name: 'VA电子', game_name: 'VA电子', category_id: 'realbet', category_name: '电子', mobile_img: '/static/newImg/index/game/dianzi/VA电子.avif', app_state: 1, is_hot: 0, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 24 },
        { id: 114, game_code: 'electronic_25', game_type: 0, platform_name: 'WG电子', game_name: 'WG电子', category_id: 'realbet', category_name: '电子', mobile_img: '/static/newImg/index/game/dianzi/WG电子.avif', app_state: 1, is_hot: 0, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 25 },
        { id: 115, game_code: 'electronic_26', game_type: 0, platform_name: 'WL电子', game_name: 'WL电子', category_id: 'realbet', category_name: '电子', mobile_img: '/static/newImg/index/game/dianzi/WL电子.avif', app_state: 1, is_hot: 0, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 26 },
        { id: 116, game_code: 'electronic_27', game_type: 0, platform_name: 'YB电子', game_name: 'YB电子', category_id: 'realbet', category_name: '电子', mobile_img: '/static/newImg/index/game/dianzi/YB电子.avif', app_state: 1, is_hot: 0, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 27 },
        { id: 117, game_code: 'electronic_28', game_type: 0, platform_name: 'YGR电子', game_name: 'YGR电子', category_id: 'realbet', category_name: '电子', mobile_img: '/static/newImg/index/game/dianzi/YGR电子.avif', app_state: 1, is_hot: 0, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 28 },
        { id: 118, game_code: 'electronic_29', game_type: 0, platform_name: '盛世电子', game_name: '盛世电子', category_id: 'realbet', category_name: '电子', mobile_img: '/static/newImg/index/game/dianzi/盛世电子.avif', app_state: 1, is_hot: 0, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 29 }
      ];

      // 棋牌游戏数据 - 12条
      const jokerList = [
        { id: 119, game_code: 'card_1', game_type: 0, platform_name: 'BS棋牌', game_name: 'BS棋牌', category_id: 'joker', category_name: '棋牌', mobile_img: '/static/newImg/index/game/qipai/BS棋牌.avif', app_state: 1, is_hot: 0, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 1 },
        { id: 120, game_code: 'card_2', game_type: 0, platform_name: 'DB棋牌', game_name: 'DB棋牌', category_id: 'joker', category_name: '棋牌', mobile_img: '/static/newImg/index/game/qipai/DB棋牌.avif', app_state: 1, is_hot: 0, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 2 },
        { id: 121, game_code: 'card_3', game_type: 0, platform_name: 'FG棋牌', game_name: 'FG棋牌', category_id: 'joker', category_name: '棋牌', mobile_img: '/static/newImg/index/game/qipai/FG棋牌.avif', app_state: 1, is_hot: 0, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 3 },
        { id: 122, game_code: 'card_4', game_type: 0, platform_name: 'JDB棋牌', game_name: 'JDB棋牌', category_id: 'joker', category_name: '棋牌', mobile_img: '/static/newImg/index/game/qipai/JDB棋牌.avif', app_state: 1, is_hot: 0, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 4 },
        { id: 123, game_code: 'card_5', game_type: 0, platform_name: 'JILI棋牌', game_name: 'JILI棋牌', category_id: 'joker', category_name: '棋牌', mobile_img: '/static/newImg/index/game/qipai/JILI棋牌.avif', app_state: 1, is_hot: 0, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 5 },
        { id: 124, game_code: 'card_6', game_type: 0, platform_name: 'KX棋牌', game_name: 'KX棋牌', category_id: 'joker', category_name: '棋牌', mobile_img: '/static/newImg/index/game/qipai/KX棋牌.avif', app_state: 1, is_hot: 0, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 6 },
        { id: 125, game_code: 'card_7', game_type: 0, platform_name: 'LEG棋牌', game_name: 'LEG棋牌', category_id: 'joker', category_name: '棋牌', mobile_img: '/static/newImg/index/game/qipai/LEG棋牌.avif', app_state: 1, is_hot: 0, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 7 },
        { id: 126, game_code: 'card_8', game_type: 0, platform_name: 'MG棋牌', game_name: 'MG棋牌', category_id: 'joker', category_name: '棋牌', mobile_img: '/static/newImg/index/game/qipai/MG棋牌.avif', app_state: 1, is_hot: 0, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 8 },
        { id: 127, game_code: 'card_9', game_type: 0, platform_name: 'SGWIN棋牌', game_name: 'SGWIN棋牌', category_id: 'joker', category_name: '棋牌', mobile_img: '/static/newImg/index/game/qipai/SGWIN棋牌.avif', app_state: 1, is_hot: 0, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 9 },
        { id: 128, game_code: 'card_10', game_type: 0, platform_name: 'WG棋牌', game_name: 'WG棋牌', category_id: 'joker', category_name: '棋牌', mobile_img: '/static/newImg/index/game/qipai/WG棋牌.avif', app_state: 1, is_hot: 0, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 10 },
        { id: 129, game_code: 'card_11', game_type: 0, platform_name: 'WL棋牌', game_name: 'WL棋牌', category_id: 'joker', category_name: '棋牌', mobile_img: '/static/newImg/index/game/qipai/WL棋牌.avif', app_state: 1, is_hot: 0, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 11 },
        { id: 130, game_code: 'card_12', game_type: 0, platform_name: '开元棋牌', game_name: '开元棋牌', category_id: 'joker', category_name: '棋牌', mobile_img: '/static/newImg/index/game/qipai/开元棋牌.avif', app_state: 1, is_hot: 0, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 12 }
      ];

      // 捕鱼游戏数据 - 20条
      const gamingList = [
        { id: 131, game_code: 'fishing_1', game_type: 0, platform_name: 'BBIN捕鱼', game_name: 'BBIN捕鱼', category_id: 'gaming', category_name: '捕鱼', mobile_img: '/static/newImg/index/game/buyu/BBIN捕鱼.avif', app_state: 1, is_hot: 0, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 1 },
        { id: 132, game_code: 'fishing_2', game_type: 0, platform_name: 'BG捕鱼', game_name: 'BG捕鱼', category_id: 'gaming', category_name: '捕鱼', mobile_img: '/static/newImg/index/game/buyu/BG捕鱼.avif', app_state: 1, is_hot: 0, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 2 },
        { id: 133, game_code: 'fishing_3', game_type: 0, platform_name: 'BS捕鱼', game_name: 'BS捕鱼', category_id: 'gaming', category_name: '捕鱼', mobile_img: '/static/newImg/index/game/buyu/BS捕鱼.avif', app_state: 1, is_hot: 0, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 3 },
        { id: 134, game_code: 'fishing_4', game_type: 0, platform_name: 'CHOICE捕鱼', game_name: 'CHOICE捕鱼', category_id: 'gaming', category_name: '捕鱼', mobile_img: '/static/newImg/index/game/buyu/CHOICE捕鱼.avif', app_state: 1, is_hot: 0, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 4 },
        { id: 135, game_code: 'fishing_5', game_type: 0, platform_name: 'CQ9捕鱼', game_name: 'CQ9捕鱼', category_id: 'gaming', category_name: '捕鱼', mobile_img: '/static/newImg/index/game/buyu/CQ9捕鱼.avif', app_state: 1, is_hot: 0, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 5 },
        { id: 136, game_code: 'fishing_6', game_type: 0, platform_name: 'DS捕鱼', game_name: 'DS捕鱼', category_id: 'gaming', category_name: '捕鱼', mobile_img: '/static/newImg/index/game/buyu/DS捕鱼.avif', app_state: 1, is_hot: 0, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 6 },
        { id: 137, game_code: 'fishing_7', game_type: 0, platform_name: 'FC捕鱼', game_name: 'FC捕鱼', category_id: 'gaming', category_name: '捕鱼', mobile_img: '/static/newImg/index/game/buyu/FC捕鱼.avif', app_state: 1, is_hot: 0, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 7 },
        { id: 138, game_code: 'fishing_8', game_type: 0, platform_name: 'JDB捕鱼', game_name: 'JDB捕鱼', category_id: 'gaming', category_name: '捕鱼', mobile_img: '/static/newImg/index/game/buyu/JDB捕鱼.avif', app_state: 1, is_hot: 0, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 8 },
        { id: 139, game_code: 'fishing_9', game_type: 0, platform_name: 'JILI捕鱼', game_name: 'JILI捕鱼', category_id: 'gaming', category_name: '捕鱼', mobile_img: '/static/newImg/index/game/buyu/JILI捕鱼.avif', app_state: 1, is_hot: 0, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 9 },
        { id: 140, game_code: 'fishing_10', game_type: 0, platform_name: 'Joker捕鱼', game_name: 'Joker捕鱼', category_id: 'gaming', category_name: '捕鱼', mobile_img: '/static/newImg/index/game/buyu/Joker捕鱼.avif', app_state: 1, is_hot: 0, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 10 },
        { id: 141, game_code: 'fishing_11', game_type: 0, platform_name: 'LEG捕鱼', game_name: 'LEG捕鱼', category_id: 'gaming', category_name: '捕鱼', mobile_img: '/static/newImg/index/game/buyu/LEG捕鱼.avif', app_state: 1, is_hot: 0, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 11 },
        { id: 142, game_code: 'fishing_12', game_type: 0, platform_name: 'MG捕鱼', game_name: 'MG捕鱼', category_id: 'gaming', category_name: '捕鱼', mobile_img: '/static/newImg/index/game/buyu/MG捕鱼.avif', app_state: 1, is_hot: 0, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 12 },
        { id: 143, game_code: 'fishing_13', game_type: 0, platform_name: 'MW捕鱼', game_name: 'MW捕鱼', category_id: 'gaming', category_name: '捕鱼', mobile_img: '/static/newImg/index/game/buyu/MW捕鱼.avif', app_state: 1, is_hot: 0, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 13 },
        { id: 144, game_code: 'fishing_14', game_type: 0, platform_name: 'RSG捕鱼', game_name: 'RSG捕鱼', category_id: 'gaming', category_name: '捕鱼', mobile_img: '/static/newImg/index/game/buyu/RSG捕鱼.avif', app_state: 1, is_hot: 0, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 14 },
        { id: 145, game_code: 'fishing_15', game_type: 0, platform_name: 'WG捕鱼', game_name: 'WG捕鱼', category_id: 'gaming', category_name: '捕鱼', mobile_img: '/static/newImg/index/game/buyu/WG捕鱼.avif', app_state: 1, is_hot: 0, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 15 },
        { id: 146, game_code: 'fishing_16', game_type: 0, platform_name: 'WL捕鱼', game_name: 'WL捕鱼', category_id: 'gaming', category_name: '捕鱼', mobile_img: '/static/newImg/index/game/buyu/WL捕鱼.avif', app_state: 1, is_hot: 0, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 16 },
        { id: 147, game_code: 'fishing_17', game_type: 0, platform_name: 'YB捕鱼', game_name: 'YB捕鱼', category_id: 'gaming', category_name: '捕鱼', mobile_img: '/static/newImg/index/game/buyu/YB捕鱼.avif', app_state: 1, is_hot: 0, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 17 },
        { id: 148, game_code: 'fishing_18', game_type: 0, platform_name: 'YGR捕鱼', game_name: 'YGR捕鱼', category_id: 'gaming', category_name: '捕鱼', mobile_img: '/static/newImg/index/game/buyu/YGR捕鱼.avif', app_state: 1, is_hot: 0, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 18 },
        { id: 149, game_code: 'fishing_19', game_type: 0, platform_name: '开元捕鱼', game_name: '开元捕鱼', category_id: 'gaming', category_name: '捕鱼', mobile_img: '/static/newImg/index/game/buyu/开元捕鱼.avif', app_state: 1, is_hot: 0, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 19 },
        { id: 150, game_code: 'fishing_20', game_type: 0, platform_name: '盛世捕鱼', game_name: '盛世捕鱼', category_id: 'gaming', category_name: '捕鱼', mobile_img: '/static/newImg/index/game/buyu/盛世捕鱼.avif', app_state: 1, is_hot: 0, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 20 }
      ];

      // 真人游戏数据 - 12条
      const sportList = [
        { id: 151, game_code: 'realperson_1', game_type: 0, platform_name: '0857真人', game_name: '0857真人', category_id: 'sport', category_name: '真人', mobile_img: '/static/newImg/index/game/zhenren/0857真人.avif', app_state: 1, is_hot: 0, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 1 },
        { id: 152, game_code: 'realperson_2', game_type: 0, platform_name: 'BBIN真人', game_name: 'BBIN真人', category_id: 'sport', category_name: '真人', mobile_img: '/static/newImg/index/game/zhenren/BBIN真人.avif', app_state: 1, is_hot: 0, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 2 },
        { id: 153, game_code: 'realperson_3', game_type: 0, platform_name: 'BG真人', game_name: 'BG真人', category_id: 'sport', category_name: '真人', mobile_img: '/static/newImg/index/game/zhenren/BG真人.avif', app_state: 1, is_hot: 0, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 3 },
        { id: 154, game_code: 'realperson_4', game_type: 0, platform_name: 'CHOICE真人', game_name: 'CHOICE真人', category_id: 'sport', category_name: '真人', mobile_img: '/static/newImg/index/game/zhenren/CHOICE真人.avif', app_state: 1, is_hot: 0, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 4 },
        { id: 155, game_code: 'realperson_5', game_type: 0, platform_name: 'DB真人', game_name: 'DB真人', category_id: 'sport', category_name: '真人', mobile_img: '/static/newImg/index/game/zhenren/DB真人.avif', app_state: 1, is_hot: 0, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 5 },
        { id: 156, game_code: 'realperson_6', game_type: 0, platform_name: 'EVO真人', game_name: 'EVO真人', category_id: 'sport', category_name: '真人', mobile_img: '/static/newImg/index/game/zhenren/EVO真人.avif', app_state: 1, is_hot: 0, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 6 },
        { id: 157, game_code: 'realperson_7', game_type: 0, platform_name: 'HRG真人', game_name: 'HRG真人', category_id: 'sport', category_name: '真人', mobile_img: '/static/newImg/index/game/zhenren/HRG真人.avif', app_state: 1, is_hot: 0, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 7 },
        { id: 158, game_code: 'realperson_8', game_type: 0, platform_name: 'MG真人', game_name: 'MG真人', category_id: 'sport', category_name: '真人', mobile_img: '/static/newImg/index/game/zhenren/MG真人.avif', app_state: 1, is_hot: 0, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 8 },
        { id: 159, game_code: 'realperson_9', game_type: 0, platform_name: 'OG真人', game_name: 'OG真人', category_id: 'sport', category_name: '真人', mobile_img: '/static/newImg/index/game/zhenren/OG真人.avif', app_state: 1, is_hot: 0, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 9 },
        { id: 160, game_code: 'realperson_10', game_type: 0, platform_name: 'SEXY真人', game_name: 'SEXY真人', category_id: 'sport', category_name: '真人', mobile_img: '/static/newImg/index/game/zhenren/SEXY真人.avif', app_state: 1, is_hot: 0, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 10 },
        { id: 161, game_code: 'realperson_11', game_type: 0, platform_name: 'WL真人', game_name: 'WL真人', category_id: 'sport', category_name: '真人', mobile_img: '/static/newImg/index/game/zhenren/WL真人.avif', app_state: 1, is_hot: 0, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 11 },
        { id: 162, game_code: 'realperson_12', game_type: 0, platform_name: 'WM真人', game_name: 'WM真人', category_id: 'sport', category_name: '真人', mobile_img: '/static/newImg/index/game/zhenren/WM真人.avif', app_state: 1, is_hot: 0, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 12 }
      ];

      // 区块链游戏数据 - 8条
      const conciseList = [
        { id: 164, game_code: 'blockchain_1', game_type: 0, platform_name: 'BGaming区块链', game_name: 'BGaming区块链', category_id: 'concise', category_name: '区块链', mobile_img: '/static/newImg/index/game/qukuailian/BGaming区块链.avif', app_state: 1, is_hot: 0, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 1 },
        { id: 165, game_code: 'blockchain_2', game_type: 0, platform_name: 'Funkygames区块链', game_name: 'Funkygames区块链', category_id: 'concise', category_name: '区块链', mobile_img: '/static/newImg/index/game/qukuailian/Funkygames区块链.avif', app_state: 1, is_hot: 0, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 2 },
        { id: 166, game_code: 'blockchain_3', game_type: 0, platform_name: 'JDB区块链', game_name: 'JDB区块链', category_id: 'concise', category_name: '区块链', mobile_img: '/static/newImg/index/game/qukuailian/JDB区块链.avif', app_state: 1, is_hot: 0, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 3 },
        { id: 167, game_code: 'blockchain_4', game_type: 0, platform_name: 'JILI区块链', game_name: 'JILI区块链', category_id: 'concise', category_name: '区块链', mobile_img: '/static/newImg/index/game/qukuailian/JILI区块链.avif', app_state: 1, is_hot: 0, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 4 },
        { id: 168, game_code: 'blockchain_5', game_type: 0, platform_name: 'MW区块链', game_name: 'MW区块链', category_id: 'concise', category_name: '区块链', mobile_img: '/static/newImg/index/game/qukuailian/MW区块链.avif', app_state: 1, is_hot: 0, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 5 },
        { id: 169, game_code: 'blockchain_6', game_type: 0, platform_name: 'Spribe区块链', game_name: 'Spribe区块链', category_id: 'concise', category_name: '区块链', mobile_img: '/static/newImg/index/game/qukuailian/Spribe区块链.avif', app_state: 1, is_hot: 0, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 6 },
        { id: 170, game_code: 'blockchain_7', game_type: 0, platform_name: 'T1区块链', game_name: 'T1区块链', category_id: 'concise', category_name: '区块链', mobile_img: '/static/newImg/index/game/qukuailian/T1区块链.avif', app_state: 1, is_hot: 0, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 7 },
        { id: 171, game_code: 'blockchain_8', game_type: 0, platform_name: 'WG区块链', game_name: 'WG区块链', category_id: 'concise', category_name: '区块链', mobile_img: '/static/newImg/index/game/qukuailian/WG区块链.avif', app_state: 1, is_hot: 0, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 8 }
      ];

      // 彩票游戏数据 - 3条
      const lotteryList = [
        { id: 172, game_code: 'lottery_1', game_type: 0, platform_name: 'BBIN彩票', game_name: 'BBIN彩票', category_id: 'lottery', category_name: '彩票', mobile_img: '/static/newImg/index/game/caipiao/BBIN彩票.avif', app_state: 1, is_hot: 0, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 1 },
        { id: 173, game_code: 'lottery_2', game_type: 0, platform_name: 'WG彩票', game_name: 'WG彩票', category_id: 'lottery', category_name: '彩票', mobile_img: '/static/newImg/index/game/caipiao/WG彩票.avif', app_state: 1, is_hot: 0, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 2 },
        { id: 174, game_code: 'lottery_3', game_type: 0, platform_name: '盛世彩票', game_name: '盛世彩票', category_id: 'lottery', category_name: '彩票', mobile_img: '/static/newImg/index/game/caipiao/盛世彩票.avif', app_state: 1, is_hot: 0, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 3 }
      ];

      // 体育游戏数据 - 10条
      const tiyuList = [
        { id: 175, game_code: 'sport_1', game_type: 0, platform_name: 'BTI体育', game_name: 'BTI体育', category_id: 'tiyu', category_name: '体育', mobile_img: '/static/newImg/index/game/tiyu/BTI体育.avif', app_state: 1, is_hot: 0, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 1 },
        { id: 176, game_code: 'sport_2', game_type: 0, platform_name: 'FB体育', game_name: 'FB体育', category_id: 'tiyu', category_name: '体育', mobile_img: '/static/newImg/index/game/tiyu/FB体育.avif', app_state: 1, is_hot: 0, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 2 },
        { id: 177, game_code: 'sport_3', game_type: 0, platform_name: 'IM体育', game_name: 'IM体育', category_id: 'tiyu', category_name: '体育', mobile_img: '/static/newImg/index/game/tiyu/IM体育.avif', app_state: 1, is_hot: 0, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 3 },
        { id: 178, game_code: 'sport_4', game_type: 0, platform_name: 'KY体育', game_name: 'KY体育', category_id: 'tiyu', category_name: '体育', mobile_img: '/static/newImg/index/game/tiyu/KY体育.avif', app_state: 1, is_hot: 0, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 4 },
        { id: 179, game_code: 'sport_5', game_type: 0, platform_name: 'NEWBBIN体育', game_name: 'NEWBBIN体育', category_id: 'tiyu', category_name: '体育', mobile_img: '/static/newImg/index/game/tiyu/NEWBBIN体育.avif', app_state: 1, is_hot: 0, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 5 },
        { id: 180, game_code: 'sport_6', game_type: 0, platform_name: 'Poly体育', game_name: 'Poly体育', category_id: 'tiyu', category_name: '体育', mobile_img: '/static/newImg/index/game/tiyu/Poly体育.avif', app_state: 1, is_hot: 0, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 6 },
        { id: 181, game_code: 'sport_7', game_type: 0, platform_name: 'WG体育', game_name: 'WG体育', category_id: 'tiyu', category_name: '体育', mobile_img: '/static/newImg/index/game/tiyu/WG体育.avif', app_state: 1, is_hot: 0, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 7 },
        { id: 182, game_code: 'sport_8', game_type: 0, platform_name: '三昇体育', game_name: '三昇体育', category_id: 'tiyu', category_name: '体育', mobile_img: '/static/newImg/index/game/tiyu/三昇体育.avif', app_state: 1, is_hot: 0, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 8 },
        { id: 183, game_code: 'sport_9', game_type: 0, platform_name: '沙巴体育', game_name: '沙巴体育', category_id: 'tiyu', category_name: '体育', mobile_img: '/static/newImg/index/game/tiyu/沙巴体育.avif', app_state: 1, is_hot: 0, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 9 },
        { id: 184, game_code: 'sport_10', game_type: 0, platform_name: '皇冠体育', game_name: '皇冠体育', category_id: 'tiyu', category_name: '体育', mobile_img: '/static/newImg/index/game/tiyu/皇冠体育.avif', app_state: 1, is_hot: 0, is_recent: 0, is_favorite: 0, has_name: 1, sort_order: 10 }
      ];

      // 最近游戏数据 - 6条
      const recentList = [
        { id: 201, game_code: 'recent_1', game_type: 0, platform_name: 'BG真人', game_name: 'BG真人', category_id: 'recent', category_name: '最近', mobile_img: '/static/newImg/index/game/zuijin/BG真人.avif', app_state: 1, is_hot: 0, is_recent: 1, is_favorite: 0, has_name: 1, sort_order: 1 },
        { id: 202, game_code: 'recent_2', game_type: 0, platform_name: 'CHOICE真人', game_name: 'CHOICE真人', category_id: 'recent', category_name: '最近', mobile_img: '/static/newImg/index/game/zuijin/CHOICE真人.avif', app_state: 1, is_hot: 0, is_recent: 1, is_favorite: 0, has_name: 1, sort_order: 2 },
        { id: 203, game_code: 'recent_3', game_type: 0, platform_name: 'DB真人', game_name: 'DB真人', category_id: 'recent', category_name: '最近', mobile_img: '/static/newImg/index/game/zuijin/DB真人.avif', app_state: 1, is_hot: 0, is_recent: 1, is_favorite: 0, has_name: 1, sort_order: 3 },
        { id: 204, game_code: 'recent_4', game_type: 0, platform_name: 'EVO真人', game_name: 'EVO真人', category_id: 'recent', category_name: '最近', mobile_img: '/static/newImg/index/game/zuijin/EVO真人.avif', app_state: 1, is_hot: 0, is_recent: 1, is_favorite: 0, has_name: 1, sort_order: 4 },
        { id: 205, game_code: 'recent_5', game_type: 0, platform_name: 'HRG真人', game_name: 'HRG真人', category_id: 'recent', category_name: '最近', mobile_img: '/static/newImg/index/game/zuijin/HRG真人.avif', app_state: 1, is_hot: 0, is_recent: 1, is_favorite: 0, has_name: 1, sort_order: 5 },
        { id: 206, game_code: 'recent_6', game_type: 0, platform_name: 'MG真人', game_name: 'MG真人', category_id: 'recent', category_name: '最近', mobile_img: '/static/newImg/index/game/zuijin/MG真人.avif', app_state: 1, is_hot: 0, is_recent: 1, is_favorite: 0, has_name: 1, sort_order: 6 }
      ];

      // 收藏游戏数据 - 3条
      const favoriteList = [
        { id: 301, game_code: 'favorite_1', game_type: 0, platform_name: 'BBIN捕鱼', game_name: 'BBIN捕鱼', category_id: 'favorite', category_name: '收藏', mobile_img: '/static/newImg/index/game/shoucang/BBIN捕鱼.avif', app_state: 1, is_hot: 0, is_recent: 0, is_favorite: 1, has_name: 1, sort_order: 1 },
        { id: 302, game_code: 'favorite_2', game_type: 0, platform_name: 'BG捕鱼', game_name: 'BG捕鱼', category_id: 'favorite', category_name: '收藏', mobile_img: '/static/newImg/index/game/shoucang/BG捕鱼.avif', app_state: 1, is_hot: 0, is_recent: 0, is_favorite: 1, has_name: 1, sort_order: 2 },
        { id: 303, game_code: 'favorite_3', game_type: 0, platform_name: 'BS捕鱼', game_name: 'BS捕鱼', category_id: 'favorite', category_name: '收藏', mobile_img: '/static/newImg/index/game/shoucang/BS捕鱼.avif', app_state: 1, is_hot: 0, is_recent: 0, is_favorite: 1, has_name: 1, sort_order: 3 }
      ];

      // 注入到localStorage
      localStorage.setItem('hotList', JSON.stringify(hotGames));
      localStorage.setItem('recentList', JSON.stringify(recentList));
      localStorage.setItem('favoriteList', JSON.stringify(favoriteList));
      localStorage.setItem('realbetList', JSON.stringify(realbetList));
      localStorage.setItem('jokerList', JSON.stringify(jokerList));
      localStorage.setItem('gamingList', JSON.stringify(gamingList));
      localStorage.setItem('sportList', JSON.stringify(sportList));
      localStorage.setItem('conciseList', JSON.stringify(conciseList));
      localStorage.setItem('lotteryList', JSON.stringify(lotteryList));
      localStorage.setItem('tiyuList', JSON.stringify(tiyuList));

      // 更新store
      this.$store.commit('changGameList');
    },
    openCheckIn() {
      if (!this.$store.state.token) {
        this.loginNewShow = true;
        return;
      }
      this.checkinShow = true;
    },
    handleSign() {
      this.tipShow = true;
    },
    openGogao(item) {
      if (item && item.id) {
        this.$router.push({ path: '/noticeDetail', query: { id: item.id, cateid: 11 } });
      }
    },
    changtanshow() {
      this.tanshow = !this.tanshow;
    },
    changGameType(type) {
      // this.gameType = type;
      this.$router.push({
        name: 'gameList',
        query: { type } 
      })
    },
    openGameMore(){
      this.$router.push({
        name: 'gameMore',
        // query: { name: '真人', type: 0, code: '0000' } 
      })
    },
    openTabsMore(){
      this.$router.push({
        name: 'moreMenu',
      })
    },
    getVisibleMoreList() {
      return this.morePopupList
        .filter(item => item.status === 1)
        .sort((a, b) => a.sort - b.sort);
    },
    toggleMorePopup() {
      if (this.showMorePopup) {
        this.closeMorePopup();
        return;
      }
      const list = this.getVisibleMoreList();
      const cols = 5;
      const rows = Math.ceil(list.length / cols);
      // 基于样式计算弹框预估高度
      const fontSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
      const rem = (val) => val * fontSize;
      const iconH = rem(0.65);
      const iconMB = rem(0.12);
      const nameH = rem(0.24) * 1.2 + 0.5; // 约0.288rem，加一点安全余量
      const rowH = iconH + iconMB + nameH; // 每一项行高
      const rowGap = rem(0.4); // grid行间距
      const paddV = rem(0.2) * 2; // 上下padding
      const border = 2;
      const popupHeight = rows * rowH + (rows - 1) * rowGap + paddV + border;

      const xiding = this.$refs.xidingRef;
      let topVal = 0;
      if (xiding) {
        const rect = xiding.getBoundingClientRect();
        topVal = rect.bottom;
      }
      const vh = window.innerHeight;
      const gap = rem(0.15); // 底部安全间距
      const spaceBelow = vh - topVal;

      // 打开弹框的操作（供同步/异步调用）
      const openIt = () => {
        const rect = xiding ? xiding.getBoundingClientRect() : { bottom: topVal };
        this.morePopupTop = rect.bottom + 'px';
        this.showMorePopup = true;
        this.$nextTick(() => {
          document.body.style.overflow = 'hidden';
        });
      };

      if (popupHeight + gap > spaceBelow) {
        // 需要先滚动页面：把"更多"这一行顶到屏幕高度的 30% 位置
        const targetTop = vh * 0.3;
        const xidingRect = xiding.getBoundingClientRect();
        const currentTop = xidingRect.top;
        const diff = currentTop - targetTop;
        const currentScroll =
          window.pageYOffset ||
          document.documentElement.scrollTop ||
          document.body.scrollTop ||
          0;
        const targetScroll = Math.max(0, currentScroll + diff);
        window.scrollTo(0, targetScroll);
        // 等待滚动稳定后再打开
        setTimeout(openIt, 250);
      } else {
        openIt();
      }
    },
    closeMorePopup() {
      this.showMorePopup = false;
      document.body.style.overflow = '';
    },
    openAppDownloadPopup() {
      this.showAppDownloadPopup = true;
      document.body.style.overflow = 'hidden';
    },
    closeAppDownloadPopup() {
      this.showAppDownloadPopup = false;
      document.body.style.overflow = '';
    },
    handleMoreItemClick(item) {
      // jumpType: 0不跳转 1url跳转 2弹框
      if (item.jumpType === 0) {
        this.closeMorePopup();
        return;
      }
      if (item.jumpType === 1) {
        if (item.jumpUrl) {
          if (item.query) {
            this.$router.push({ path: item.jumpUrl, query: item.query }).catch(() => {});
          } else {
            this.$parent.goNav(item.jumpUrl);
          }
        }
        this.closeMorePopup();
        return;
      }
      if (item.jumpType === 2) {
        // 弹框类型：按 action 字段或名称分发
        const action = item.action || item.name;
        if (action === 'language') {
          this.closeMorePopup();
          this.showLangPopup = true;
        } else if (action === 'appDownload') {
          this.closeMorePopup();
          this.openAppDownloadPopup();
        } else if (action === 'share') {
          this.doCopy(this.$store.state.appInfo.h5_url);
          this.$parent.showTost(1, '分享链接已复制');
          this.closeMorePopup();
        } else if (item.name === '在线客服') {
          this.$parent.openKefu();
          this.closeMorePopup();
        } else {
          this.$parent.showTost(1, item.name + '弹框功能');
          this.closeMorePopup();
        }
      }
    },
    doCopy(msg) {
      let cInput = document.createElement('input');
      cInput.style.opacity = '0';
      cInput.value = msg;
      document.body.appendChild(cInput);
      // 选取文本框内容
      cInput.select();

      // 执行浏览器复制命令
      // 复制命令会将当前选中的内容复制到剪切板中（这里就是创建的input标签）
      // Input要在正常的编辑状态下原生复制方法才会生效
      document.execCommand('copy');

      // 复制成功后再将构造的标签 移除
      this.$parent.showTost(1, '复制成功！');
    },
    changleftshow() {
      this.leftshow = !this.leftshow;
    },
    getBanList() {
      let that = this;
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/bannerList', { type: 2 })
        .then(res => {
          if (res.code != 200) {
            that.showTost(0, res.message);
          }
          if (res.code == 200) {
            // that.bannerList = res.data;
             that.bannerList = [
              {src: '/static/newImg/index/banner/001.avif'},
              {src: '/static/newImg/index/banner/002.avif'},
              {src: '/static/newImg/index/banner/003.avif'},
              {src: '/static/newImg/index/banner/004.avif'},
              {src: '/static/newImg/index/banner/005.avif'},
              {src: '/static/newImg/index/banner/006.avif'},
              {src: '/static/newImg/index/banner/007.avif'},
              {src: '/static/newImg/index/banner/008.avif'},
              {src: '/static/newImg/index/banner/009.avif'},
              {src: '/static/newImg/index/banner/010.avif'},
              {src: '/static/newImg/index/banner/011.avif'},
              {src: '/static/newImg/index/banner/012.avif'},
              {src: '/static/newImg/index/banner/013.avif'},
              {src: '/static/newImg/index/banner/014.avif'},
              {src: '/static/newImg/index/banner/015.avif'},
              {src: '/static/newImg/index/banner/016.avif'},
              {src: '/static/newImg/index/banner/017.avif'},
             ]
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    homenotice() {
      let that = this;
      that.$apiFun.post('/api/homenotice', {}).then(res => {
        if (res.code != 200) {
          that.showTost(0, res.message);
          return;
        }
        const data = res.data || {};
        that.homePaomadeng = data.latest || null;
        that.homeUnread = data.unread || 0;
        that.ok = true;
      });
    },
    handleColseLoginNew(){
      this.loginNewShow = false;
      setTimeout(() => {
        this.ssActiveShow = true;
      },500)
    },
    openLogin(type) {
      this.loginDefaultType = type;
      this.loginNewShow = true;
    },
    goToSlide(index, title) {
      // console.log(index);
      // console.log(title);
      this.$refs.swiperActive.swipeTo(index);
    },
    goActivityDetail(template, activity_id) {
      if (!this.$store.state.token) {
        this.$parent.showTost(0, '请先登录');
        return;
      }
      this.$router.push({
        path: '/activityDetail',
        query: { template, activity_id, from: 'home' }
      });
    },
    goNotice() {
      this.$router.push({
        path: '/notice',
        query: { noticeType: 2, from: 'home' }
      });
    },
    onChange(index) {
      this.current = index;
    },
    changhongbashow() {
      this.hongbashow = false;
    },
    changappShow() {
      this.appShow = false;
    },
    // 处理图片加载失败，显示默认图片
    handleImageError(event) {
      event.target.src = '/static/image/errorImage.jpg';
    },
    onGameContentScroll() {
      this.sideAdScrolling = true;
      clearTimeout(this._gameScrollTimer);
      this._gameScrollTimer = setTimeout(() => {
        this.sideAdScrolling = false;
      }, 300);
    },
  },
  mounted() {
    let that = this;
    let scrollTimer = null;
    window.addEventListener('scroll', () => {
      that.sideAdScrolling = true;
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(() => {
        that.sideAdScrolling = false;
      }, 300);
    });
    // 默认弹出签到弹框，方便预览
    //that.$nextTick(() => {
      //that.checkinShow = true;
    //});
  },
  updated() {
    let that = this;
  },
  activated() {
    // 回到首页时恢复banner自动轮播
    this.bannerAutoplay = 3000;
  },
  deactivated() {
    // 离开首页时停掉轮播，避免keep-alive容器被销毁后vant定时器仍访问已移除DOM报错
    this.bannerAutoplay = 0;
  },
  beforeDestroy() {
    document.body.style.overflow = '';
    this.bannerAutoplay = 0;
  },
};
</script>
<style lang="scss" scoped>
@import '../../../static/css/2d87bbdbffeb4734e5c7.css';
@import '../../../static/css/common.css';

.index-bg{margin-bottom: 68px;}
.gonggao-bg {
  background: linear-gradient(0deg,#292A2c 0%,rgba(41, 42, 44, 0.7) 23.78%);
  padding: 0;
  border-radius: 0 0 .3rem .3rem;
  border-bottom: 1px solid #3B3C3D;
  margin-top: 1.35rem;
}
.top-swiper-box{background: #292A2c;}
.swiper-box{height: 112px;background: #000c;padding: 2rem 0.3rem 0px;
  .menu-icons{
    display: flex;
    justify-content: space-between;
    padding: 0;
    .menu-icon-item{
      flex: 1;
      text-align: center;
      img{ width: 1.2rem; height: auto; }
    }
  }
  .swiper-box-item{
    border-radius: .3rem;
    img{border-radius: .3rem;}
  }
}

/* sports-box 暂时注释
.sports-box {
  margin: 0.35rem auto;
  padding: 0 0.3rem;
  .sports-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.1rem;
    .sports-title {
      display: flex;
      align-items: center;
      gap: 0.1rem;
      font-size: 0.4rem;
      color: #fff;
      font-weight: 600;
    }
    .sports-more {
      font-size: 0.3rem;
      color: #DFB372;
      display: flex;
      align-items: center;
      gap: 0.05rem;
    }
  }
  .sports-list {
    display: flex;
    gap: 0.2rem;
    overflow-x: auto;
    padding-bottom: 0.1rem;
    &::-webkit-scrollbar { display: none; }
  }
  .sports-card {
    width: 6.5rem;
    background: #1a1a1a;
    border-radius: 0.25rem;
    padding: 0.2rem;
    flex-shrink: 0;
    border: 1px solid #3b3c3d;

    .sports-match-info {
      display: flex;
      align-items: center;
      gap: 0.1rem;
      font-size: 0.25rem;
      color: #999;
      margin-bottom: 0.15rem;
      .match-time { color: #999; width:33%;font-size: 0.25rem;}
      .match-league { color: #e3e3e3; width:40%;font-size: 0.25rem;}
      .match-num { color: #DFB372; margin-left: auto; display: flex; align-items: center; gap: 0.02rem; font-size: 0.25rem; white-space: nowrap;}
    }
    .sports-teams {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 0.15rem;
      .team {
        width:33%;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 0.05rem;
        .team-flag {
          width: 1rem;
          height: 0.55rem;
          object-fit: contain;
        }
        .team-name {
          font-size: 0.28rem;
          color: #fff;
        }
      }
      .vs-wrap {
        display: flex;
        flex-direction: column;
        align-items: center;
        .vs-text {
          font-size: 0.35rem;
          color: #fff;
          font-weight: 600;
        }
        .vs-sub {
          font-size: 0.25rem;
          color: #999;
        }
      }
    }
    .sports-odds {
      display: flex;
      gap: 0.1rem;
      .odd-item {
        flex: 1;
        background: #2a2a2a;
        border-radius: 0.08rem;
        padding: 0.1rem 0;
        text-align: center;
        .odd-label {
          display: block;
          font-size: 0.3rem;
          color: #999;
          margin-bottom: 0.02rem;
        }
        .odd-value {
          display: block;
          font-size: 0.3rem;
          color: #fff;
          font-weight: 600;
        }
      }
    }
  }
}
*/

.game-category-box {
  padding: 0 .2rem;
  margin-bottom: 0.3rem;
  margin-top: 0.3rem;
  height:17rem;
  .game-category-layout {
    display: flex;
    gap: 0.2rem;
  }
  .game-sidebar {
    width: 26.5%;
    flex-shrink: 0;
    .sidebar-item {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      gap: 0.1rem;
      padding: 0.15rem 0.1rem;
      margin-bottom: 0.15rem;
      font-size: 0.3rem;
      color: #999;
      letter-spacing: 0.15rem;
      cursor: pointer;
      border-radius: 0.15rem;
      transition: all 0.3s;
      line-height: 0.85rem;
      background: #323233;
      &.active {
        // color: #DFB372;
        background: rgba(223, 179, 114, 0.1);
      }
      img {
        width: 0.4rem;
        height: 0.4rem;
      }
    }
  }
  .game-content {
    flex: 1;
    overflow-y: auto;
    max-height: 17rem;
    background: #1a1a1a;
    &::-webkit-scrollbar { display: none; }
    .game-top-tabs {
      display: flex;
      justify-content: space-around;
      margin-bottom: 0.2rem;
      padding: 0.2rem 0;
      span {
        text-align: center;
        font-size: 0.35rem;
        color: #fff;
        cursor: pointer;
        padding-bottom: 0.15rem;
        border-bottom: 2px solid transparent;
        &.active {
          color: #DFB372;
          border-bottom-color: #DFB372;
        }
      }
    }
    .game-section {
      margin-bottom: 0.3rem;
      .section-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 0.15rem;
        .section-title {
          display: flex;
          align-items: center;
          gap: 0.1rem;
          font-size: 0.35rem;
          color: #fff;
          font-weight: 600;
          img {
            width: 0.35rem;
            height: 0.35rem;
          }
        }
        .section-all {
          font-size: 0.3rem;
          color: #999;
          cursor: pointer;
        }
      }
      .jackpot-banner {
        position: relative;
        margin-bottom: 0.15rem;
        img {
          width: 100%;
          border-radius: 0.1rem;
        }
        .jackpot-text {
          position: absolute;
          top: 58%;
          left: 50%;
          transform: translate(-50%, -50%);
          color: #ffff38;
          font-size: 0.4rem;
          font-weight: bold;
          text-shadow: 0 0 10px rgba(0, 0, 0, 0.8);
          letter-spacing: 0.08rem;
        }
      }
      .game-grid {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 0.15rem;
        .game-card {
          position: relative;
          border-radius: 0.1rem;
          overflow: hidden;
          cursor: pointer;
          img {
            width: 100%;
            display: block;
            border-radius: 0.35rem;
          }
          .game-card-label {
            position: absolute;
            top: 0.05rem;
            left: 0.05rem;
            background: rgba(223, 179, 114, 0.9);
            color: #000;
            font-size: 0.2rem;
            padding: 0.02rem 0.1rem;
            border-radius: 0.05rem;
          }
          .game-card-collect {
            position: absolute;
            top: 0.1rem;
            right: 0.1rem;
            width: 0.5rem;
            height: 0.5rem;
            cursor: pointer;
            background: #999;
          }
          .game-card-head {
            display: inline-block;
            width: 0.55rem;
            height: 0.5rem;
            vertical-align: middle;
            border-radius: 0;
            margin-right: 0.05rem;
          }
          .game-card-name {
            position: absolute;
            bottom: 0;
            left: 50%;
            transform: translateX(-50%);
            color: #f1f4fc;
            font-size: 0.28rem;
            font-weight: 600;
            text-shadow: 0 1px 3px rgba(0,0,0,0.8);
            white-space: nowrap;
          }
        }
      }
      .section-expand {
        text-align: center;
        padding: 0.3rem 0;
        font-size: 0.3rem;
        color: #999;
        cursor: pointer;
        span {
          display: inline-flex;
          align-items: center;
          gap: 0.05rem;
        }
        .loaded-text {
          color: #666;
          cursor: default;
        }
      }
    }
  }
}

.gameHots-box{
  margin: .35rem auto;
  padding: 0 .3rem;
  .title{
    font-size: .35rem;
    color: #fff;
  }
  .gameHots-cell{
    // margin-top: .21rem;
    .gameHots-item{
      display: flex;
      justify-content: center;
      .hots-content{
        width: 1.8rem;
        margin: 0 .1rem;
        text-align: center;
        .name{
          font-size: .32rem;
          color: #BEBEBE;
        }
      }
      .big{width: 4.78rem;}
      .grid{
        
        flex-wrap: wrap;
        .hots-content{width: 45%;text-align: center;margin-bottom: .1rem;}
         .name{
          font-size: .28rem;
          color: #BEBEBE;
         }
      }
    }
}
}
.gameAward-box{
  margin: .35rem auto;
  .title{
    font-size: .35rem;
    color: #fff;
  }
  .gameAward{
    margin-top: .21rem;
    border-radius: .2rem;
    .notice-content{
      padding: 0 .16rem;
      text-align: center;
      .name{
        font-size: .30rem;
        color: #898989;
        display: block;
        line-height: .1rem;
        span{
          color: #FA5D70;
        }
      }
      .bei{
        display: block;
        font-size: .26rem;
        color: #FFAA09;
      }
    }
}
}

.index-gameBoxs-new{
    margin: .21rem auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 .3rem;
    .cell-big{width: 100%;height: 3.48rem;border-radius: .2rem;color:#fff;background: #292A2C;border: .014rem solid #3B3C3D;position: relative;
      .hot{position: absolute;top: .2rem;right: 0;}
      .cell{position: relative;width: 100%;height: 100%;display: flex;align-items: center;
        .title{position: absolute;top: .2rem;left: .2rem;border-left: .024rem solid #DFB372;padding-left: .15rem;
          .cn{font-size: .32rem;font-weight: 400;}
          .en{font-size: .2rem;margin-top: .05rem;}
         }
      }
    }
    .cell-middle{width: 100%;height: 2.48rem;margin-top: .21rem;color:#fff;
      .cell{position: relative;width: 48%;height: 100%;border-radius: .2rem;background: #292A2C;border: .014rem solid #3B3C3D;
        .title{position: absolute;top: .2rem;left: .2rem;border-left: .024rem solid #DFB372;padding-left: .15rem;
          .cn{font-size: .30rem;font-weight: 400;}
          .en{font-size: .19rem;margin-top: .05rem;}
         }
      }
    }
    .cell-small{width: 100%;height: 3.15rem;margin-top: .21rem;color:#fff;
      .cell{position: relative;width: 23%;height: 100%;border-radius: .2rem;background: #292A2C;border: .014rem solid #3B3C3D;
        .title{position: absolute;top: .2rem;left: .2rem;border-left: .024rem solid #DFB372;padding-left: .15rem;
          .cn{font-size: .30rem;font-weight: 400;}
          .en{font-size: .19rem;margin-top: .05rem;}
        }
        .img-game1{width: 2.15rem; height: 2.08rem; position: absolute;bottom: 0; left: 0; overflow: hidden;background-image: url('/static/newImg/game/img_syyx2_4.avif');background-size: cover; background-position: center;}
        .img-game2{width: 2.15rem; height: 2.08rem; position: absolute;bottom: 0; left: 0; overflow: hidden;background-image: url('/static/newImg/game/img_syyx2_5.avif');background-size: cover; background-position: center;}
        .img-game3{width: 2.15rem; height: 2.08rem; position: absolute;bottom: 0; left: 0; overflow: hidden;background-image: url('/static/newImg/game/img_syyx2_8.avif');background-size: cover; background-position: center;}
        .img-game4{width: 2.15rem; height: 2.08rem; position: absolute;bottom: 0; left: 0; overflow: hidden;background-image: url('/static/newImg/game/img_syyx2_102.avif');background-size: cover; background-position: center;}
      }
    }
}

.lianxi-box{padding: .2rem .3rem;box-sizing: border-box;
  .title{font-size: .36rem;color: #898989;margin-bottom: .2rem;}
}

.domainModal_content__1nBgc {
  overflow: auto;
}
// 轮播样式
.swiper-dots {
  display: flex;
  position: absolute;
  left: 40px;
  bottom: 10px;
  width: 48px;
  height: 24px;
  background-image: url(data:image/png;base64,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);
  background-size: 100% 100%;
}
.swiper-dots .num {
  width: 24px;
  height: 24px;
  border-radius: 50px;
  font-size: 16px;
  color: #fff;
  text-align: center;
  line-height: 24px;
}
.swiper-dots .sign {
  position: absolute;
  top: 0;
  left: 50%;
  line-height: 24px;
  font-size: 8px;
  color: #fff;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
}
// 主页头部标题

.homeHeder {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 50px;
  display: flex;
  box-sizing: border-box;
  padding: 0 30px;
  z-index: 999;
  align-items: center;
  justify-content: space-between;
  .leftImg {
    width: 19px;
    height: 19px;
  }
  .rbox {
    display: flex;
    height: 100%;
    align-items: center;
    font-size: 0.24rem;
    font-family: PingFangSC-Regular, sans-serif;
    img {
      width: 32px;
      height: 32px;
    }
  }
}
.leftbox {
  width: 7.5rem;
  height: 100%;
  background-color: #ede9e7;
  color: #cf866b;
  .side__main__1NhyG {
    box-sizing: border-box;
    padding: 0 20px;
    h3 {
      font-size: 20px;
      font-weight: 400;
      margin: 0;
      padding-top: 72px;
    }
    .side__vip__1dW8w {
      background: url('/static/style/sidebr_vip_card.1ce7485811699286f87aae1827de7acf.png') no-repeat;
      background-size: 100% 100%;
      box-sizing: border-box;
      padding: 20px;
      color: #fff;
      position: relative;
      p {
        color: hsla(0, 0%, 100%, 0.6);
        font-size: 12px;
        margin: 5px 0 0 0;
      }
      .topxs {
        font-size: 16px;
      }
      dd {
        float: right;
        border: 0.02rem solid #fff;
        border-radius: 0.24rem;
        height: 0.48rem;
        line-height: 0.48rem;
        width: 1.88rem;
        text-align: center;
        font-size: 10px;
        position: absolute;
        top: 20px;
        right: 20px;
      }
    }
  }
  ul {
    list-style: none;
    margin-top: 0.36rem;
    li {
      display: block;
      line-height: 0.96rem;
      height: 0.96rem;
      border-bottom: 0.02rem solid #e6ebf6;
      color: #4e6693;
      font-size: 0.28rem;
      padding: 0 0.14rem;
      img {
        width: 0.36rem;
        vertical-align: middle;
        margin: -0.04rem 0.24rem 0 0;
      }
      span {
        float: right;
      }
    }
  }
  .nisd {
    position: absolute;
    width: 4.72rem;
    height: 0.8rem;
    line-height: 0.8rem;
    left: 0.9rem;
    bottom: 1rem;
    background: #dfe5ff;
    border-radius: 0.4rem;
    border: 0;
    color: #4e6693;
    font-size: 0.28rem;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      vertical-align: middle;
      margin: -0.04rem 0.08rem 0 -0.08rem;
      width: 0.32rem;
    }
  }
}
.gonggao {
  // width: 90%;
  padding: 0 .16rem 0 .23rem;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.caosuo {
  color: #fff;
  width: 95%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .user-area {
    flex-shrink: 0;
    position: relative;
  }
  .user-top {
    display: flex;
    align-items: center;
    gap: 0.05rem;
    position: relative;
    .user-arrow {
      cursor: pointer;
      margin-right: 0.05rem;
    }
    .user-name {
      font-size: 0.35rem;
      font-weight: 600;
    }
    .copy-icon {
      width: 0.5rem;
      height: 0.5rem;
      margin-left:0.1rem;
    }
  }
  .user-bottom {
    display: flex;
    align-items: center;
    gap: 0.05rem;
    margin-top: 0.1rem;
    .cny-icon {
      width: 0.5rem;
      height: 0.5rem;
    }
    .refresh-icon {
      width: 0.5rem;
      height: 0.5rem;
      transform: rotate(90deg);
    }
    .balance {
      font-size: .35rem;
      color: #ffaa09;
      border-bottom: 1px solid #ffaa09;
      padding-bottom: 0.1rem;
    }
  }
  .login-btns {
    display: flex;
    gap: 0.1rem;
    .btn-login {
      padding: 0.08rem 0.35rem;
      border: 1px solid #DFB372;
      border-radius: 0.06rem;
      color: #DFB372;
      font-size: 0.3rem;
      text-align: center;
      margin-right:0.2rem;
    }
    .btn-register {
      padding: 0.08rem 0.35rem;
      background: #DFB372;
      border-radius: 0.06rem;
      color: #000;
      font-size: 0.3rem;
      text-align: center;
    }
  }
  .riggs {
    display: flex;
    align-items: center;
    gap: 0.2rem;
    .lisImg {
      width: 1.2rem;
      text-align: center;
      font-size: 0.3rem;
      color: #ccc;
      line-height: 1.2;
      img {
        width: 0.75rem;
        height: 0.65rem;
        display: block;
        margin: 0 auto;
        margin-bottom: 0.1rem;
      }
    }
  }
}

.ren-box{padding: 0 .3rem 0;
  // .lisImg{
  //   img{}
  // }
}

.user-dropdown {
  position: absolute;
  top: 55%;
  left: 0.25rem;
  background: #1a1a1a;
  border-radius: 0.2rem;
  padding: 0.35rem 0.3rem;
  width: 4.5rem;
  z-index: 9999;
  .dropdown-title {
    font-size: 0.35rem;
    color: #e3e3e3;
    margin-bottom: 0.15rem;
    font-weight: 400;
  }
  .dropdown-item {
    display: flex;
    align-items: center;
    gap: 0.1rem;
    padding: 0.35rem 0.2rem;
    font-size: 0.35rem;
    color: #969799;
    cursor: pointer;
    border-radius: 0.05rem;
    .id-label {
      color: #999;
      font-size: 0.35rem;
      margin-right: 0.05rem;
    }
    &.active {
      background: #1a1a1a;
      color:#d1ae52;
    }
  }
}

.xiding {
  padding: 6px 0;
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  z-index: 0;
  overflow: visible;
}

// 游戏
.gameBoxs {
  // -webkit-box-shadow: inset 0 0.08rem 0.16rem rgb(227 170 150 / 50%);
  // box-shadow: inset 0 0.08rem 0.16rem rgb(227 170 150 / 50%);
  // border: 0.014rem solid rgba(227, 170, 150, 0.5);
  box-sizing: border-box;
  padding: 10px;
  color: #cf866b;
  height: 518px;
  display: flex;
  justify-content: space-between;
  .lfst {
    width: 36px;
    height: 400px;
    background: #eff3ff;
    border-radius: 20px;
    border: 1px solid #fff;
    .ls.active {
      color: #fff;
      background: #cf866b;
    }
    .ls {
      text-align: center;
      border-radius: 20px;
      padding: 7px 0;
      img {
        width: 30px;
        display: block;
        margin: 0 auto;
      }
      span {
        font-size: 12px;
        display: block;
      }
    }
  }
  .rigts {
    flex: 1;
    overflow: auto;
    height: 420px;
    box-sizing: border-box;
    padding: 0 12px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    img {
      width: 48%;
      border-radius: 10px;
      margin-top: 10px;
    }
  }
}
// app下载
.appbox {
  background:#000c;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 0.87rem;
  box-sizing: border-box;
  padding: 0 0.2rem;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 999;
  .btn{ color: #fff;background: #ffbc6a;border: thin solid #ffbc6a;font-size: 0.24rem; border: none; border-radius: 0.15rem;width: 2rem;text-align: center; height: 0.65rem;line-height: 0.65rem;}
  .colse {
    width: 0.5rem;
    margin-left: 0.1rem;
  }
  .logo {
    width: .8rem;
    margin: 0 0.2rem;
  }
  .testz {
    flex: 1;
    .tit {
      font-size: 0.35rem;
      font-weight: 700;
      color: #fff;
    }
    .cx {
      font-size: 0.26rem;
      color: #fff;
    }
  }
}


.ssActive-box{
  position: relative;
  width: 8.3rem;
  height: 7.5rem;
  margin:0 auto;
  border-radius: 0.25rem;
  overflow: hidden;
  transform :translateY(0);
  background: #292A2c;
  .my-swipeactive{
    .van-swipe-item a{
      width:100%;
      height: 6.5rem;
      display :inline-block;
    }
  }
}
.close-ssActive, .close-loginNew{text-align: center;margin-top: .3rem;}

.topInfo{
  width: calc(100% - 0.4rem);
  padding: 0 .2rem;
  background-color: #1E1F24;
  border-bottom: thin solid #3B3C3D;
  position: fixed;
  color: #fff;
  z-index: 1;
  .top-bg-layer{
    display: flex;
    position: absolute;
    top: 0; left: 0; right: 0; bottom: 0;
    .top-bg-left{ width: 25%; img{ width: 100%; height: 100%; object-fit: cover; } }
    .top-bg-center{ width: 50%; img{ width: 100%; height: 100%; object-fit: cover; } }
    .top-bg-right{ width: 25%; img{ width: 100%; height: 100%; object-fit: cover; } }
  }
  .top-content-layer{
    display: flex;
    align-items: center;
    position: relative;
    z-index: 1;
    .top-logo{ width: 40%; }
    .top-center{ width: 30%; display: flex; justify-content: center; }
    .top-right{ width: 30%; display: flex; justify-content: flex-end; align-items: center; height: 100%; }
    .search-icon{ margin-right: 0; }
    .search-wrap{ display: flex; flex-direction: column; align-items: center; justify-content: center; margin-right: 0.2rem; height: 100%; }
    .search-text{ font-size: 0.3rem; color: #999999; margin-top: 0.05rem; }
  }
}

.side-ad {
  position: fixed;
  bottom: 80px;
  z-index: 999;
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
  transition: transform 0.3s ease;
}
.side-ad-left {
  left: 0;
  .side-ad-close {
    position: absolute;
    top: 0;
    right: -0.2rem;
  }
  &.scrolling {
    transform: translateX(-50%);
  }
}
.side-ad-right {
  right: 0;
  .side-ad-close {
    position: absolute;
    top: 0;
    left: -0.2rem;
  }
  &.scrolling {
    transform: translateX(50%);
  }
}
.side-ad-img {
  width: 1.5rem;
  height: 1.5rem;
}

#redPacket3{
  position: fixed;
  left: 0;
  bottom: 160px;
  z-index: 999;
  cursor: pointer;
  .close{
    position: absolute;
    top: 0;
    right: -10px;
    width: 20px;
  }
}
#redPacket4{
  position: fixed;
  left: 0;
  bottom: 80px;
  z-index: 999;
  cursor: pointer;
  .close{
    position: absolute;
    top: 0;
    right: -10px;
    width: 20px;
  }
}
#redPacket1{
  position: fixed;
  right: 0;
  bottom: 80px;
  z-index: 999;
  cursor: pointer;
  .close{
    position: absolute;
    top: 0;
    left: -10px;
    width: 20px;
  }
}
#redPacket5{
  position: fixed;
  right: 0;
  bottom: 160px;
  z-index: 999;
  cursor: pointer;
  .close{
    position: absolute;
    top: 0;
    left: -10px;
    width: 20px;
  }
}

</style>
<style scoped>
.gameAward-box /deep/ .van-notice-bar{height: 80px;background-color: transparent}
.ssActive-box /deep/ .van-tabs__nav--card{margin: 0 !important;border: none !important;height: 35px!important;}
.ssActive-box /deep/ .van-tabs__nav--card .van-tab{border-color: transparent !important;}
</style>
<style>
/* 隐藏全局滚动条 */
::-webkit-scrollbar {
  width: 0;
  height: 0;
}
/* 签到弹框 */
.checkin-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.75);
  z-index: 1000;
  box-sizing: border-box;
  display: block;
}

/* 装饰图 qd_style_6_qdtc.avif：弹框外，遮罩层内，位于弹框上方 */
.checkin-deco-img {
  position: absolute;
  top: 4%;
  left: 50%;
  transform: translateX(-50%);
  width: 80%;
  max-width: 90%;
  height: auto;
  max-height: 12vh;
  z-index: 2;
  pointer-events: none;
  display: block;
}

.checkin-popup {
  position: absolute;
  top: 10%;
  left: 50%;
  transform: translateX(-50%);
  width: 90%;
  max-width: 9rem;
  background: #1E1F24;
  border-radius: 0.3rem;
  box-sizing: border-box;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  /* 装饰图(8vh + 12vh) + 弹框 ≤ 80vh → 弹框 ≤ 60vh，留余量 58vh */
  /* max-height: calc(80vh - 8vh - 12vh); */
  height:80%;
  padding: 0;
  z-index: 1;
  border: 1px solid #333;
}

/* 标题 sign-name */
.sign-name {
  padding: 0.3rem 0.3rem 0.05rem;
  text-align: center;
}
.sign-name p {
  margin: 0;
  font-size: 0.45rem;
  font-weight: 700;
  color: #e3e3e3;
  letter-spacing: 0.04rem;
}

/* 连续签到信息 sign-summary */
.sign-summary {
  padding: 0.1rem 0.3rem 0.2rem;
}
.sign-summary .summary-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.28rem;
  color: #999;
}
.sign-summary .item-left { color: #999; }
.sign-summary .item-left .num { color: #fff; font-weight: 600; margin: 0 0.02rem; }
.sign-summary .item-right { color: #999; display: inline-flex; align-items: center; }
.sign-summary .item-right .gold { color: #d1ae52; font-weight: 600; margin: 0 0.02rem; }

.refresh-icon {
  width: 0.28rem;
  height: 0.28rem;
  vertical-align: middle;
  margin-left: 0.05rem;
  cursor: pointer;
}

/* 主体滚动区 sign-main */
.sign-main {
  margin: 0 0.25rem;
  background: transparent;
  overflow-y: auto;
  flex: 1 1 auto;
  min-height: 0;
  box-sizing: border-box;
}

/* 3列签到格子 sign-grid */
.sign-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0.2rem;
  padding: 0.1rem 0;
}

.sign-item {
  position: relative;
  background: #0a0a0a;
  border-radius: 0.15rem;
  padding: 0.2rem 0.1rem 0.2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  min-height: 2.15rem;
  box-sizing: border-box;
}

/* 额外奖励绿色角标 */
.sign-extra {
  position: absolute;
  top: 0;
  right: 0;
  background: #1fae27;
  color: #fff;
  font-size: 0.24rem;
  padding: 0.02rem 0.1rem;
  border-top-left-radius: 0.15rem;
  border-bottom-right-radius: 0.12rem;
  line-height: 1.4;
}

/* 奖励图案 sign-reward-pattern */
.sign-reward-pattern {
  width: 100%;
  /* margin-top: 0.1rem; */
  text-align: center;
}
.sign-reward-pattern .reward-picture {
  width: 1.65rem;
  height: 1.65rem;
  object-fit: contain;
  display: inline-block;
}

/* 奖励金额 sign-reward-desc（黄色） */
.sign-reward-desc {
  width: 100%;
  margin-top: 0;
  text-align: center;
  margin-bottom:0.2rem;
}
.sign-reward-desc .reward-text.yellow {
  color: #e6a832;
  font-size: 0.3rem;
  font-weight: 600;
  line-height: 1.2;
}

/* 底部：签到按钮 / 第X天 sign-caption */
.sign-caption {
  width: 100%;
  margin-top: 0.1rem;
  text-align: center;
  min-height: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 签到按钮（绿色胶囊） */
.btn-sign {
  background: #1fae27;
  color: #fff;
  border: none;
  border-radius: 0.4rem;
  padding: 0.06rem 0.3rem;
  font-size: 0.26rem;
  cursor: pointer;
  line-height: 1.5;
  box-sizing: border-box;
  margin: 0;
}

/* 第X天（深灰） */
.day-label {
  color: #666;
  font-size: 0.32rem;
  line-height: 1.2;
}

/* 活动说明 sign-intro */
.sign-intro {
  margin: 0.2rem 0 0.1rem;
  background: #14151a;
  border-radius: 0.15rem;
  padding: 0.1rem 0.12rem;
}
.sign-intro-title { margin-bottom: 0.08rem; }
.sign-intro-title .title-box {
  display: inline-flex;
  align-items: center;
  background: #dfb372;
  padding: 0.12rem 0.4rem;
  border-top-right-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;
}
.sign-intro-title .title-text {
  color: #3a2a1a;
  font-size: 0.3rem;
  font-weight: 600;
}
.sign-intro-title .title-arrow {
  display: inline-block;
  width: 0;
  height: 0;
  border: 0.1rem solid transparent;
  border-top-color: #3a2a1a;
  margin-left: 0.12rem;
  transform: translateY(0.04rem);
}
.sign-intro-content { padding: 0.15rem 0.25rem; }
.sign-intro-content p {
  font-size: 0.32rem;
  color: #bbb;
  line-height: 1.6;
  margin-bottom: 0.05rem;
}

/* 所需充值 / 投注 sign-need */
.sign-need {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.15rem 0.35rem 0.05rem;
  font-size: 0.24rem;
  color: #999;
}
.sign-need .need-item.fail { color: #999; }
.sign-need .need-item.right { text-align: right; }
.sign-need .need-item .num { color: #F44336; font-weight: 600; }
.sign-need .need-item .num span { color: #999; font-weight: 400; }

/* 不再提示 sign-persist（弹框内底部） */
.sign-persist {
  display: flex;
  justify-content: space-between;
  padding: 0.1rem 0.35rem 0.3rem;
  font-size: 0.24rem;
  color: #ccc;
}
.sign-persist .persist-item {
  display: flex;
  align-items: center;
  gap: 0.06rem;
  cursor: pointer;
}
.sign-persist .persist-item input[type="checkbox"] {
  margin: 0;
  width: 0.28rem;
  height: 0.28rem;
  accent-color: #d1ae52;
}

/* 关闭按钮（弹框外下方中央，白色圆形背景，黑色×） */
.checkin-close-btn {
  position: absolute;
  left: 50%;
  bottom: 5vh;
  transform: translateX(-50%);
  width: 0.75rem;
  height: 0.75rem;
  border-radius: 50%;
  background: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 5;
  box-shadow: 0 0.05rem 0.2rem rgba(0, 0, 0, 0.4);
  box-sizing: border-box;
}
.checkin-close-btn svg {
  width: 0.5rem;
  height: 0.5rem;
  display: block;
}

/* 温馨提示弹框 */
.tip-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1001;
}

.tip-popup {
  width: 65%;
  /* max-width: 3rem; */
  background: #292a2c;
  border-radius: 0.1rem;
  padding: 0.35rem 0.25rem 0.55rem 0.25rem;
  text-align: center;
  line-height: 0.5rem;
}

.tip-title {
  font-size: 0.35rem;
  color: #fff;
  font-weight: 600;
  margin-bottom: 0.25rem;
}

.tip-content {
  font-size: 0.3rem;
  color: #fff;
  line-height: 1.6;
  margin-bottom: 0.35rem;
}

.tip-btns {
  display: flex;
  gap: 0.1rem;
  justify-content: center;
}

.tip-btn-close {
  flex: 1;
  background: transparent;
  color: #ccc;
  border: 1px solid #888;
  border-radius: 0.3rem;
  padding: 0.1rem 0;
  font-size: 0.28rem;
  cursor: pointer;
}

.tip-btn-download {
  flex: 1;
  background: linear-gradient(180deg, #f5d6a8 0%, #e6c08a 100%);
  color: #3a2a1a;
  border: none;
  border-radius: 0.3rem;
  padding: 0.2rem 0;
  font-size: 0.3rem;
  cursor: pointer;
}

.brand-intro {
  margin: 0.3rem 0.15rem;
  background: #1a1a1a;
  border-radius: 0.1rem;
  overflow: hidden;
}

.brand-desc {
  padding: 0.2rem 0.25rem;
  font-size: 0.3rem;
  color: #fff;
  line-height: 1.6;
}

.brand-logo {
  padding: 0 0.25rem;
}

.brand-copyright {
  padding: 0.15rem 0.25rem 0.25rem;
  font-size: 0.25rem;
  color: #f0c059;
  text-align: center;
  margin-bottom: 1rem;
}

/* 更多弹框遮罩层 */
.more-popup-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 99998;
}

/* 更多弹框悬浮样式 */
.more-popup-float {
  position: fixed;
  right: 0.2rem;
  width: 70%;
  background: #1a1a1a;
  border: 1px solid #333;
  border-radius: 0.2rem;
  padding: 0.2rem 0.2rem;
  z-index: 99999;
}
.more-popup-float .more-popup-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 0.4rem 0.1rem;
}
.more-popup-float .more-popup-item {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.more-popup-float .more-popup-item .more-popup-icon {
  width: 0.75rem;
  height: 0.65rem;
  /* background: #292a2c;border-radius: 50%; */
  margin-bottom: .12rem;
}
.more-popup-float .more-popup-item .more-popup-icon img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.more-popup-float .more-popup-item .more-popup-name {
  color: #999999;
  font-size: 0.24rem;
  text-align: center;
  line-height: 1.2;
}

// 语言选择弹窗
.lang-popup-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 999999;
  display: flex;
  align-items: center;
  justify-content: center;

  .lang-popup-content {
    width: 76%;
    background: #292A2C;
    border-radius: 0.2rem;
    padding: 0.5rem 0.4rem 0.8rem;
    position: relative;

    .lang-popup-title {
      text-align: center;
      color: #fff;
      font-size: 0.35rem;
      margin-bottom: 0.4rem;
    }

    .lang-popup-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0.3rem 0;
      border-bottom: 1px solid #3a3a3a;
      color: #fff;
      font-size: 0.3rem;

      .lang-radio-active {
        width: 0.4rem;
        height: 0.4rem;
        border-radius: 50%;
        background: #d1ae52;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }

    .lang-popup-close {
      position: absolute;
      bottom: -1rem;
      left: 50%;
      transform: translateX(-50%);
      width: 0.6rem;
      height: 0.6rem;
      border-radius: 50%;
      border: 2px solid #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }
  }
}

/* APP下载弹框 */
.app-download-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  z-index: 999999;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.app-download-popup {
  width: 92%;
  background: #1a1a1a;
  border: 1px solid #333;
  border-radius: 0.3rem;
  padding: 0.4rem 0.3rem 0.45rem;
  box-sizing: border-box;
  position: relative;
}

.app-download-header {
  display: flex;
  align-items: center;
  margin-bottom: 0.45rem;
}

.app-download-logo {
  width: 1.3rem;
  height: 1.3rem;
  border-radius: 0.2rem;
  background: #000;
  border: 1px solid #5d4624;
  overflow: hidden;
  flex-shrink: 0;
}

.app-download-logo img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.app-download-title-wrap {
  margin-left: 0.25rem;
  display: flex;
  align-items: center;
  flex: 1;
  flex-wrap: wrap;
}

.app-download-title {
  font-size: 0.36rem;
  font-weight: normal;
  color: #fff;
}

.app-download-badge {
  width: 0.5rem;
  height: 0.5rem;
  margin-left: 0.08rem;
}

.app-download-btns {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.app-download-row {
  display: flex;
  gap: 0.25rem;
}

/* 按钮通用布局（颜色由下面具体类覆盖） */
.app-download-btn {
  position: relative;
  flex: 1;
  height: 0.95rem;
  border-radius: 0.25rem;
  border: 1px solid #d1ae52;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.3rem;
  font-weight: normal;
  cursor: pointer;
  overflow: hidden;
}

.app-download-btn .i-icon {
  margin-right: 0.1rem;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 0.45rem;
  height: 0.45rem;
}

.app-download-btn .i-icon img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

/* 4. 桌面快捷方式：无背景，只有金边金字 */
.app-download-btn-desktop {
  background: transparent;
  color: #d1ae52;
  border-color: #d1ae52;
}

/* 5. 官方应用版：纯金背景+金边+深棕文字 */
.app-download-btn-official {
  background: #d1ae52;
  color: #703904;
  border-color: #d1ae52;
}

/* 安卓版第二个按钮：图标在左，右侧文字上下排列 */
.app-download-btn-android-login {
  gap: 0.1rem;
}

.android-login-text {
  display: flex;
  flex-direction: column;
  gap: 0.05rem;
}

.android-login-top {
  font-size: 0.3rem;
  color: #703904;
  line-height: 1.2;
}

.android-login-bottom {
  display: flex;
  align-items: center;
  gap: 0.06rem;
  font-size: 0.24rem;
  color: #703904;
  line-height: 1;
}

.android-login-check {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 0.3rem;
  height: 0.3rem;
  background: #07c160;
  border-radius: 50%;
}

/* 第2行：合并大容器（左80%快捷APP + 右20%教程，共用一个边框） */
.app-download-merged {
  position: relative;
  height: 0.95rem;
  /* 6. 快捷APP背景色和边框色都是 #d1ae52 */
  background: #d1ae52;
  border: 1px solid #d1ae52;
  border-radius: 0.25rem;
  display: flex;
  align-items: center;
  overflow: hidden;
  cursor: pointer;
}

.app-download-hot-tag {
  position: absolute;
  top: 0.06rem;
  left: 0.06rem;
  background: #ff4d4f;
  color: #fff;
  font-size: 0.2rem;
  padding: 0.04rem 0.1rem;
  border-radius: 0.1rem;
  font-weight: normal;
  line-height: 1.2;
  z-index: 2;
}

.app-download-merged-left {
  width: 80%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  /* 6. 快捷APP 文字颜色 #703904 */
  color: #703904;
  font-size: 0.3rem;
  font-weight: normal;
}

.app-download-merged-left .i-icon {
  margin-right: 0.1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 0.45rem;
  height: 0.45rem;
  flex-shrink: 0;
}

.app-download-merged-left .i-icon img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.app-download-merged-split {
  width: 1px;
  height: 60%;
  background: #a07a28;
  flex-shrink: 0;
}

.app-download-merged-right {
  width: 20%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #703904;
  font-weight: normal;
  flex-shrink: 0;
}

.app-download-tutorial-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 0.03rem;
  line-height: 1;
}

.app-download-tutorial-icon img {
  width: 0.45rem;
  height: 0.45rem;
  display: block;
}

.app-download-tutorial-text {
  font-size: 0.24rem;
  line-height: 1;
}

.app-download-close {
  margin-top: 0.45rem;
  width: 0.6rem;
  height: 0.6rem;
  border-radius: 50%;
  border: 2px solid #fff;
  background: #000;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/mode/index.vue